import {
  Box,
  Grid,
  Paper,
  TextField,
  Checkbox,
  FormLabel,
  Button,
  Typography,
  Backdrop,
  CircularProgress,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Popper,
  List,
  ListItem,
  ClickAwayListener,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { API, graphqlOperation } from 'aws-amplify';
import {
  entityOptions,
  gstCategoryOptions,
  gstCategoryOptions1,
  initialValues,
  msmeOptions,
  validationSchema,
  cashAccounts,
  humanizeKey,
} from '../../../utils/customerData';
import { MoneyFormatv2 } from '../../../library/MoneyFormat';
import { useFormik } from 'formik';
import { useEffect, useState, useRef, useMemo } from 'react';
import './AddCustomer.css';
import AddIcon from '@mui/icons-material/Add';
import { useLocation } from 'react-router-dom';
import {
  createBankDetails,
  createPartyAddressEntity,
  createPartyContact,
  createPartyImages,
  createPartyMaster,
  updateAccountMaster,
} from '../../../graphql';
import { createPartyCreditDetails, createPartyGSTDetails, createPartyTransaction } from '../../../graphql';
import { showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import ConfirmCancel from '../../../components/modals/confirmCancel';
import { uploadToServer } from '../../../library/upload';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import CustomAutocomplete from '../FormComponents/CustomAutoComplete';
import { getPartyAccountData, getPartyAccountData1, getPartyMasterCust, getPartyMasterSupplier } from '../../../graphql';
import Attachment from './attachment';
import { LocationFetch } from '../../../library/LocationFetch';
import { FetchGstInDetails } from '../../../library/GstinFetch';
import DraggableAction from '../../../components/Buttons/DraggableAction';
import { fetchPosList } from '../../../redux/reducers/posList';
import FormikTextField from '../FormComponents/FormikTextfield';
import FormikMoneyInput from '../FormComponents/FormikMoneyInput';
import { useThemes } from '../../../components/Theme/theme';
import useSaveShortcut from '../../../hooks/useSaveShortcut';
import { listAccountMasterv2Api } from '../../../redux/apis/accountMaster.api';
import { useGetPaymentSettingsQuery } from '../../../redux/apis/paymentSettings.api';
import NewCustomerGroup from '../../../components/DropDown/newCustomerGroup';
import { setNavigationBlocked, setModalBlocked } from '../../../redux/reducers/controllNavigation';
import useControlledNavigation from '../../../hooks/useControlledNavigation';
import { dashboardApi } from '../../../redux/apis/dashboardApi';
import { useGetCodeTranslationQuery } from '../../../redux/apis/getCodeTranslation.api';
import API_ENDPOINTS from '../../../apiEndpoints';
import { listAccountOpeningBalanceApi } from '../../../redux/apis/accountOpeningBalance.api';
import QRCode from 'qrcode';
import { isValidUPI } from '../../../library/shared';
import { upiHandles } from '../../InvoiceSettings/data';
import sampleQR from '../../../../src/assets/images/ExampleQRCode.png';
import CustomTooltip from '../../../components/CustomTooltip';
import { billingCurrencyOptions } from '../../../utils/Data/StaticData';
import { updateTitle } from '../../../redux/reducers/titleSlice';
import { matchIsValidTel, MuiTelInput } from 'mui-tel-input';
import { listAccountMasterv3Api } from '../../../features/AccountsAndGroups/api/accountMaster.api';
import dayjs from 'dayjs';

// Centralized spacing constants - Change these values to update spacing across all fields
const FIELD_SPACING = {
  padding: '0px 10px',
  marginTop: { xs: '10px', sm: '10px', md: '10px' },
};

const AddNewCustomer = ({
  partyGroupId,
  partyType,
  closePartyModal,
  setNewPartyID,
  partyParamsID,
  Type,
  newPartyName,
  view,
  listPartyDetails,
  passFn,
  setNewPartyName,
  accountId,
  onSave = () => {},
  customModal = false,
} = {}) => {
  console.log({ objects: Type, partyType });
  const { theme } = useThemes();

  const useStyles = makeStyles((theme) => ({
    root: {
      '&.css-1v7lraa-MuiPaper-root': {
        borderRadius: '15px',
      },
    },
    check: {
      '&.css-i4bv87-MuiSvgIcon-root': {
        fontSize: '20px',
      },
      color: 'red!important',
    },
    accordionRoot: {
      '&.MuiAccordion-root': {
        boxShadow: 'none',
      },
      '&.MuiAccordionSummary-content': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid black',
      },
    },

    accordionSummary: {
      '& .MuiAccordionSummary-expandIconWrapper': {
        backgroundColor: 'lightgrey',
        borderRadius: '50%',
      },
    },
  }));
  const imageRef = useRef();
  const upiRef = useRef();
  const gstref = useRef();
  const panref = useRef();
  const legalref = useRef();
  const shortref = useRef();
  const catref = useRef();
  const cityref = useRef();
  const cityrefD = useRef();
  const entityref = useRef();
  const contactref = useRef();
  const whatsappref1 = useRef();
  const mobileref = useRef();
  const whatsappref2 = useRef();
  const [billingAddress, setBillingAddress] = useState([]);
  const [deliveryAddress, setDeliveryAddress] = useState([]);
  const [bool, setBool] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [resetbool, setResetBool] = useState(0);
  const [currentDocuments, setCurrentDocuments] = useState([]);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [customerGroup, setCustomerGroup] = useState('');
  const [accountGroupData, setAccountGroupData] = useState([]);
  const [subAccountGroupData, setSubAccountGroupData] = useState([]);
  const [parentdetails, setParentdetails] = useState();
  const [bankData, setBankData] = useState();
  const [linkRecipt, setLinkRecipt] = useState(false);
  const [customerData, setCustomerData] = useState();
  const [qrupi, setQrupi] = useState('');
  const [cancelModal, setCancelModal] = useState(false);
  const [companyGstin, setCompanyGstin] = useState('');
  const [expanded, setExpanded] = useState({ panel2: true });
  const [gstApi, setGstApi] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [optionB, setOptionB] = useState([]);
  const [optionD, setOptionD] = useState([]);
  const [contactNumber, setContactNumber] = useState({
    Mobile: '',
    MobileIso: 'IN',
    MobileDial: '91',
    Whatsapp: '',
    WhatsappIso: 'IN',
    WhatsappDial: '91',
    errorFields: { Mobile: '', Whatsapp: '' },
  });
  const [contactPerson, setContactPerson] = useState({
    Mobile: '',
    MobileIso: 'IN',
    MobileDial: '91',
    Whatsapp: '',
    WhatsappIso: 'IN',
    WhatsappDial: '91',
    errorFields: { Mobile: '', Whatsapp: '' },
  });
  const location = useLocation();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  let posData = useSelector((state) => state.posListReducer);
  const dispatch = useDispatch();
  const [tdsSections, setTdsSections] = useState([]);
  const [pos, setPos] = useState([]);

  const noSpaces = (str) => str.replace(/ /g, '');
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/Party/`;

  const loc = location.pathname.includes('customer') || partyType === 'customer' ? true : false;
  const viewPage = location.pathname.includes('view') || view;
  const navigate = useControlledNavigation();
  const handleExChange = (panel) => (event, isExpanded) => {
    if (event.target.closest('.expand-icon')) {
      return;
    }
    setExpanded((prev) => ({
      ...prev,
      [panel]: isExpanded,
    }));
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    const allowedTypes = [
      'application/msword',
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'image/jpeg',
      'image/jpg',
      'image/png',
    ];

    let allFilesValid = true;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!allowedTypes.includes(file.type)) {
        showWarningSnackbar('This format is not allowed');
        allFilesValid = false;
        break;
      }
    }
    if (allFilesValid === true) {
      setAttachments((currentAttachments) => {
        if (files.length + attachments.length > 6) {
          showWarningSnackbar('You cannot add more than 6 attachments');
          return currentAttachments;
        } else {
          const newAttachments = Array.from(files).map((file) => ({
            attachmentid: currentAttachments.attachmentid ? currentAttachments.attachmentid : Date.now() + file.name,
            imagename: currentAttachments.imagename ? currentAttachments.imagename : path + '${id}/LedgerX_' + Date.now() + file.name,
            documentname: file.name,
            type: currentAttachments.type ? currentAttachments.type : file.type,
            imageurl: currentAttachments.imageurl ? currentAttachments.imageurl : URL.createObjectURL(file),
            file,
          }));
          const filteredNewAttachments = newAttachments.filter(
            (newAttachment) => !currentAttachments.some((attachment) => attachment.documentname === newAttachment.documentname)
          );

          return [...currentAttachments, ...filteredNewAttachments];
        }
      });
    } else {
      event.target.value = ''; // This resets the file input
    }

    if (imageRef.current) {
      imageRef.current.value = '';
    }
  };
  const formatPhoneNumber = (phoneValue) => {
    if (!phoneValue) return phoneValue;
    if (phoneValue.startsWith('+')) {
      // Split by space and remove the first element (country code)
      const parts = phoneValue.split(' ');
      if (parts.length > 1) {
        return parts.slice(1).join('');
      }
      // If no spaces, remove the + and first few digits (country code)
      return phoneValue.substring(1).replace(/^\d{1,4}/, '');
    }

    return phoneValue;
  };
  const handleMobileChange = (value, name, info) => {
    const dial = info?.countryCallingCode || info?.dialCode;
    setContactNumber((prev) => {
      return {
        ...prev,
        ...(value?.split(' ').length > 1
          ? {
              [name]: value,
              [`${name}Iso`]: info.countryCode ? info.countryCode : prev[`${name}Iso`],
              [`${name}Dial`]: dial,
              errorFields: {
                ...(prev.errorFields || {}),
                [name]: value && !matchIsValidTel(value) ? `${name} Number is Invalid` : '',
              },
            }
          : {
              ...prev,
              [`${name}Iso`]: info.countryCode ? info.countryCode : prev[`${name}Iso`],
              [`${name}Dial`]: dial,
            }),
      };
    });
  };

  useEffect(() => {
    if (!idParams) {
      setContactNumber((prev) => {
        const parts = contactNumber.Mobile.split(' ');

        const tail = noSpaces(parts.slice(1).join(' '));
        return {
          ...prev,
          Whatsapp: tail,
          [`WhatsappIso`]: contactNumber.MobileIso,
          [`WhatsappDial`]: contactNumber.MobileDial,
          errorFields: {
            ...(contactNumber.errorFields || {}),
            Whatsapp: contactNumber.errorFields.Mobile ? `Whatsapp Number is Invalid` : '',
          },
        };
      });
    }
  }, [contactNumber.Mobile, contactNumber.MobileIso]);

  const handlecontactPersonMobileChange = (value, name, info) => {
    const dial = info?.countryCallingCode || info?.dialCode;
    setContactPerson((prev) => {
      return {
        ...prev,

        ...(value?.split(' ').length > 1
          ? {
              [name]: value,

              [`${name}Iso`]: info.countryCode ? info.countryCode : prev[`${name}Iso`],
              // keep your original logic for Dial; adjust if you meant a different source
              [`${name}Dial`]: dial,
              errorFields: {
                ...(prev.errorFields || {}),
                [name]: value && !matchIsValidTel(value) ? `${name} Number is Invalid` : '',
              },
            }
          : {
              ...prev,
              [`${name}Iso`]: info.countryCode ? info.countryCode : prev[`${name}Iso`],
              [`${name}Dial`]: dial,
            }),
      };
    });
  };

  useEffect(() => {
    if (!idParams) {
      setContactPerson((prev) => {
        const parts = contactPerson.Mobile.split(' ');

        const tail = noSpaces(parts.slice(1).join(' '));
        return {
          ...prev,
          Whatsapp: tail,
          [`WhatsappIso`]: contactPerson.MobileIso,
          [`WhatsappDial`]: contactPerson.MobileDial,
          errorFields: {
            ...(contactPerson.errorFields || {}),
            Whatsapp: contactPerson.errorFields.Mobile ? `Whatsapp Number is Invalid` : '',
          },
        };
      });
    }
  }, [contactPerson.Mobile, contactPerson.MobileIso]);
  const queryParams = new URLSearchParams(location.search);
  const idParams = queryParams.get('id') || location.state?.id; // Get the `id` parameter
  const viewParams = queryParams.get('view') || location.state?.view;
  const existingData = location.state?.existingData;
  const customerState = {
    id: partyParamsID === '' ? '' : idParams,
    view: viewParams,
  };

  const getAccountData = async () => {
    try {
      let response;
      setBackdropOpen(true);
      const gp = loc === true ? 15 : 7;

      if (gp == 7) {
        response = await API.graphql(
          graphqlOperation(getPartyAccountData, {
            accountgroupid: gp,
            accountgroupsubid: gp,
            objecttype1: '1',
          })
        );
      } else {
        response = await API.graphql(
          graphqlOperation(getPartyAccountData1, {
            accountgroupid: gp,
            accountgroupsubid: gp,
          })
        );
      }
      const { accountGroup, subGroup, tds } = response.data;

      setAccountGroupData(accountGroup);
      setSubAccountGroupData(subGroup);
      if (tds !== null && tds !== undefined) {
        let sectionArrays = tds.map((element) => {
          return {
            option: `${element.codetext} (${element.codevalue}%)`,
            value: `${element.codevalue}`,
            section: element.codeorder,
          };
        });
        setTdsSections(sectionArrays);
      }
    } catch (error) {
      console.log(error, 'err');
      const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
      showWarningSnackbar(errorMessage);
    } finally {
      setBackdropOpen(false);
    }
  };
  console.log(existingData, 'existingData');

  useEffect(() => {
    formik.resetForm();
    setResetBool((c) => c + 1);
    const gp = loc === true ? 15 : 7;
    formik.setFieldValue('Country', 'IndiaState');
    if (partyGroupId) {
      setCustomerGroup(partyGroupId);
    } else {
      setCustomerGroup(gp);
    }
    if (partyParamsID || idParams) {
      if (partyParamsID || customModal === false) {
        if (existingData && existingData.customerData) {
          setCustomerData(existingData.customerData);
          setBillingAddress(existingData.billingAddress);
          setDeliveryAddress(existingData.deliveryAddress);
          setBankData(existingData.bankData);
          setContactNumber(existingData.contactNumber);
          setContactPerson(existingData.contactPerson);
          setAttachments(existingData.attachments);
          setBool(existingData.bool);

          // Set account data if available
          if (existingData.accountGroupData) {
            setAccountGroupData(existingData.accountGroupData);
          }
          if (existingData.subAccountGroupData) {
            setSubAccountGroupData(existingData.subAccountGroupData);
          }
          if (existingData.tdsSections) {
            setTdsSections(existingData.tdsSections);
          }

          // Populate form fields with existing data
          if (existingData.customerData && existingData.customerData[0]) {
            const customer = existingData.customerData[0];
            formik.setFieldValue('gstCategory', customer.gstcategory || '');
            formik.setFieldValue('entity', customer.entity || '');
            formik.setFieldValue('contactNumber', customer.contactnumber);
            formik.setFieldValue('Whatsapp', customer.whatsappnumber);
            formik.setFieldValue('legalName', customer.partylegalname || '');
            formik.setFieldValue('legalShortName', customer.partydisplayname || '');
            formik.setFieldValue('email', customer.email || '');
            formik.setFieldValue('pos', customer.placeofsupply || '');
            formik.setFieldValue('Comments', customer.comments || '');
            formik.setFieldValue('ConsigneeName', customer.deliveryconsigneename || '');
            formik.setFieldValue('ConsigneeGSTIN', customer.deliveryconsigneegstin || '');
            formik.setFieldValue('TDSSection', customer.tdssection || '');
            formik.setFieldValue('TDSPercentage', customer.tdspercentage || '');
            formik.setFieldValue('reg', customer.udhyamregno || '');
            formik.setFieldValue('msme', customer.msmetype || '');
            formik.setFieldValue('creditLimit', customer.relatedpartycreditdetails[0].creditlimitamount);
            formik.setFieldValue('creditPeriod', customer.relatedpartycreditdetails[0].creditperiodduration);
            formik.setFieldValue('billingCurrency', customer.relatedpartycreditdetails[0].billingcurrency);
            formik.setFieldValue('fullname', customer.relatedpartycontact[0]?.contacttypename);
            formik.setFieldValue('Designation', customer.relatedpartycontact[0]?.contactdesignationname);
            formik.setFieldValue('Mobile', customer.relatedpartycontact[0]?.phonenumber);
            formik.setFieldValue('WhatsappContact', customer.relatedpartycontact[0]?.whatsappnumber);
            formik.setFieldValue('EmailContact', customer.relatedpartycontact[0]?.email);
            formik.setFieldValue('notes', customer.relatedpartycreditdetails[0]?.notes);
            // Set PAN from GST details
            if (customer.relatedpartygstdetails && customer.relatedpartygstdetails[0]) {
              formik.setFieldValue('pan', customer.relatedpartygstdetails[0].pannumber || '');
              formik.setFieldValue('gstin', customer.relatedpartygstdetails[0].gstin || '');
            }
            setContactNumber({
              ...existingData.contactNumber,
            });
            setContactPerson({
              ...existingData.contactPerson,
            });
            setCustomerGroup(customer.groupaccountid);
            // Set bank details
            if (existingData.bankData && existingData.bankData[0]) {
              const bank = existingData.bankData[0];
              formik.setFieldValue('bankName', bank.bankname || '');
              formik.setFieldValue('bankAC', bank.bankaccountnumber || '');
              formik.setFieldValue('ifsc', bank.ifsccode || '');
              formik.setFieldValue('branch', bank.branch || '');
              formik.setFieldValue('cash', MoneyFormatv2(bank.cash) || '');
              formik.setFieldValue('notes', bank.notes || '');
              formik.setFieldValue('swiftcode', bank.swiftcode || '');
              formik.setFieldValue('upi', bank.upi || '');
            }

            // Set billing address
            if (existingData.billingAddress && existingData.billingAddress[0]) {
              const billing = existingData.billingAddress[0];
              console.log(billing, 'billing');

              formik.setFieldValue('billingAddress', billing.line1 || '');
              // formik.setFieldValue('billingAddress2', billing.addressline2 || '');
              formik.setFieldValue('City', billing.city || '');
              formik.setFieldValue('State', billing.statecode || '');
              formik.setFieldValue('District', billing.district || '');
              formik.setFieldValue('Pincode', billing.pincode || '');
              formik.setFieldValue('Country', billing.countrycode);
              formik.setFieldValue('foreignstate', billing.foreignstate);
              formik.setFieldValue('foreigndistrict', billing.foreigndistrict);
            }

            // Set delivery address
            if (existingData.deliveryAddress && existingData.deliveryAddress[0]) {
              const delivery = existingData.deliveryAddress[0];
              formik.setFieldValue('billingAddressD', delivery.line1 || '');
              // formik.setFieldValue('deliveryAddress2', delivery.addressline2 || '');
              formik.setFieldValue('CityD', delivery.city || '');
              formik.setFieldValue('StateD', delivery.statecode || '');
              formik.setFieldValue('DistrictD', delivery.district || '');
              formik.setFieldValue('PincodeD', delivery.pincode || '');
              // formik.setFieldValue('CountryD', (delivery.countrycode && ensureStateSuffix(delivery.countrycode)) || 'IndiaState');
              formik.setFieldValue('CountryD', delivery.countrycode);
              formik.setFieldValue('foreignstateD', delivery.foreignstate);
              formik.setFieldValue('foreigndistrictD', delivery.foreigndistrict);
            }
          }
        } else {
          getPartyMasterData(partyParamsID || idParams);
        }
      }
    }

    formik.validateForm();
    setAttachments([]);
    const fields = Object.keys(formik.errors);
    fields.forEach((field) => {
      formik.setFieldError(field, '');
    });
    if ((posData.posList.listPlaceOfSupply?.length ?? 0) === 0) {
      dispatch(fetchPosList());
    }

    setPos(posData.posList.listPlaceOfSupply);

    // Only call getAccountData if we don't have existing data
    if (!existingData || !existingData.accountGroupData) {
      getAccountData();
    }
  }, [loc]);

  useEffect(() => {
    setPos(posData.posList.listPlaceOfSupply);
  }, [posData.posList.listPlaceOfSupply]);

  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  useEffect(() => {
    if (saveSkipStatus == false) {
      navigate('/companysetup');
    }
    setCompanyGstin(getCompany.relatedcompanyentity[0]?.gstin);
    // formik.setFieldValue('Country', 'IndiaState');
    // formik.setFieldValue('CountryD', 'IndiaState');
  }, []);
  // console.log();

  async function getPartyMasterData(partyId) {
    try {
      setBackdropOpen(true);
      const gp = loc === true ? 15 : 7;
      let response;
      const partyApi = loc === true ? getPartyMasterCust : getPartyMasterSupplier;
      const partyVariable1 = {
        partyid: partyId,
        ObjectType1: 'PartyBilling',
        ObjectType2: 'PartyDelivery',
        ObjectType3: 'Supplier',
        ObjectType4: 1,
        ObjectID: partyId,
        accountgroupid: gp,
        accountgroupsubid: gp,
      };
      const partyVariable2 = {
        partyid: partyId,
        objecttype1: 'PartyBilling',
        objecttype2: 'PartyDelivery',
        objectid: partyId,
        accountgroupid: gp,
        accountgroupsubid: gp,
      };

      const partyVariable = loc === true ? partyVariable2 : partyVariable1;

      response = await API.graphql(graphqlOperation(partyApi, partyVariable));

      const { partyMaster, partyBilling, partyDelivery, accountGroup, bankData, subGroup } = response.data;
      setAccountGroupData(accountGroup);
      setSubAccountGroupData(subGroup);
      setBankData(bankData);
      setCustomerData(partyMaster);
      const boole = partyMaster[0]?.sameaddressflag === 1 ? true : false;
      setContactNumber({
        Mobile: formatPhoneNumber(partyMaster[0]?.contactnumber),
        MobileIso: partyMaster[0]?.contactcountry || 'IN',
        MobileDial: '91',
        Whatsapp: formatPhoneNumber(partyMaster[0]?.whatsappnumber),
        WhatsappIso: partyMaster[0]?.whatsappcountry || 'IN',
        WhatsappDial: '91',
        errorFields: { Mobile: '', Whatsapp: '' },
      });
      console.log(partyBilling, 'partyBilling');
      // console.log(partyMaster, 'partyMaster');
      setBool(boole);
      setBillingAddress(partyBilling);
      if (bankData) {
        formik.setFieldValue('bankName', bankData[0]?.bankname);
        formik.setFieldValue('bankAC', bankData[0]?.bankaccountnumber);
        formik.setFieldValue('ifsc', bankData[0]?.ifsccode);
        formik.setFieldValue('branch', bankData[0]?.branch);
        formik.setFieldValue('cash', MoneyFormatv2(bankData[0]?.cash));
        formik.setFieldValue('notes', bankData[0]?.notes);
        formik.setFieldValue('swiftcode', bankData[0]?.swiftcode);
        formik.setFieldValue('upi', bankData[0]?.upi);
      }
      generateQRCode();
      formik.setFieldValue('TDSSection', partyMaster[0]?.tdssection);
      formik.setFieldValue('TDSPercentage', partyMaster[0]?.tdspercentage);
      formik.setFieldValue('reg', partyMaster[0]?.udhyamregno);
      formik.setFieldValue('msme', partyMaster[0]?.msmetype);
      setDeliveryAddress(partyDelivery);
      formik.setFieldValue(
        'pan',
        partyMaster[0]?.relatedpartygstdetails[0]?.pannumber !== null ? partyMaster[0]?.relatedpartygstdetails[0]?.pannumber : ''
      );
      if (partyMaster[0]?.relatedpartycontact !== null) {
        formik.setFieldValue('fullname', partyMaster[0]?.relatedpartycontact[0]?.contacttypename);
        formik.setFieldValue('Designation', partyMaster[0]?.relatedpartycontact[0]?.contactdesignationname);
        formik.setFieldValue('Mobile', partyMaster[0]?.relatedpartycontact[0]?.phonenumber);
        formik.setFieldValue('WhatsappContact', partyMaster[0]?.relatedpartycontact[0]?.whatsappnumber);
        formik.setFieldValue('EmailContact', partyMaster[0]?.relatedpartycontact[0]?.email);
        setContactPerson({
          Mobile: formatPhoneNumber(partyMaster[0]?.relatedpartycontact[0]?.phonenumber),
          MobileIso: partyMaster[0]?.relatedpartycontact[0]?.contactcountry || 'IN',
          MobileDial: '91',
          Whatsapp: formatPhoneNumber(partyMaster[0]?.relatedpartycontact[0]?.whatsappnumber),
          WhatsappIso: partyMaster[0]?.relatedpartycontact[0]?.whatsappcountry || 'IN',
          WhatsappDial: '91',
          errorFields: { Mobile: '', Whatsapp: '' },
        });
      }
      formik.setFieldValue('gstCategory', partyMaster[0]?.gstcategory);
      formik.setFieldValue('contactNumber', partyMaster[0]?.contactnumber);
      setCustomerGroup(partyMaster[0]?.groupaccountid);
      setParentdetails(partyMaster[0]?.groupaccountid);
      formik.setFieldValue('ConsigneeName', partyMaster[0]?.deliveryconsigneename);
      formik.setFieldValue('ConsigneeGSTIN', partyMaster[0]?.deliveryconsigneegstin);
      formik.setFieldValue('email', partyMaster[0]?.email);

      formik.setFieldValue('Whatsapp', partyMaster[0]?.whatsappnumber);
      formik.setFieldValue('gstin', partyMaster[0]?.relatedpartygstdetails[0]?.gstin);

      formik.setFieldValue('entity', partyMaster[0]?.entity);
      formik.setFieldValue('Comments', partyMaster[0]?.comments);
      formik.setFieldValue('legalName', partyMaster[0]?.partylegalname);
      formik.setFieldValue('legalShortName', partyMaster[0]?.partydisplayname);
      formik.setFieldValue('pos', partyMaster[0]?.placeofsupply);
      formik.setFieldValue('billingCurrency', partyMaster[0]?.relatedpartycreditdetails[0]?.billingcurrency);
      formik.setFieldValue('notes', partyMaster[0]?.relatedpartycreditdetails[0]?.notes);
      const creditFormat = partyMaster[0]?.relatedpartycreditdetails[0]?.creditlimitamount;
      formik.setFieldValue('creditLimit', creditFormat);

      let linkReciptw = partyMaster[0]?.relatedpartycreditdetails[0].billwiseflag ? true : false;
      setLinkRecipt(linkReciptw);
      formik.setFieldValue('creditPeriod', partyMaster[0]?.relatedpartycreditdetails[0].creditperiodduration);

      let attach = partyMaster[0]?.relatedpartyimages;
      setAttachments(attach);
      setCurrentDocuments(attach);
      formik.setFieldValue('District', partyBilling[0]?.district);
      formik.setFieldValue('foreignstate', partyBilling[0]?.foreignstate);
      formik.setFieldValue('foreigndistrict', partyBilling[0]?.foreigndistrict);
      formik.setFieldValue('City', partyBilling[0]?.city);
      // formik.setFieldValue('Country', partyBilling[0]?.countrycode);
      // formik.setFieldValue('Country', ensureStateSuffix(partyBilling[0]?.countrycode) || 'IndiaState');
      formik.setFieldValue('Country', partyBilling[0]?.countrycode);
      formik.setFieldValue('billingAddress', partyBilling[0]?.line1);
      formik.setFieldValue('Pincode', partyBilling[0]?.pincode);
      formik.setFieldValue('State', partyBilling[0]?.statecode === 0 ? '' : partyBilling[0]?.statecode);
      if (partyDelivery) {
        formik.setFieldValue('DistrictD', partyDelivery[0]?.district);
        formik.setFieldValue('foreignstateD', partyDelivery[0]?.foreignstate);
        formik.setFieldValue('foreigndistrictD', partyDelivery[0]?.foreigndistrict);
        formik.setFieldValue('CityD', partyDelivery[0]?.city);
        formik.setFieldValue('CountryD', partyDelivery[0]?.countrycode);
        // formik.setFieldValue(
        //   'Country',
        //   (partyDelivery[0]?.countrycode && ensureStateSuffix(partyDelivery[0]?.countrycode)) || 'IndiaState'
        // );
        formik.setFieldValue('CountryD', partyDelivery[0]?.countrycode);
        formik.setFieldValue('billingAddressD', partyDelivery[0]?.line1);
        formik.setFieldValue('PincodeD', partyDelivery[0]?.pincode);
        formik.setFieldValue('StateD', partyDelivery[0]?.statecode === 0 ? '' : partyDelivery[0]?.statecode);
      }
    } catch (error) {
      console.log(error, 'err');
    } finally {
      setBackdropOpen(false);
    }
  }
  const classes = useStyles();
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema(getCompany?.relatedcompanydetailsnew[0]?.registrationtype, companyGstin),
    validateOnChange: true,
    validateOnBlur: true,
  });
  const { data: countriesList } = useGetCodeTranslationQuery(
    {
      codetype: 'Country',
    },
    {
      skip: formik.values.Country !== 'IndiaState',
    }
  );
  let CountryList = useMemo(() => {
    if (!countriesList) return [];
    return countriesList.map((element) => {
      return {
        label: element.codetext,
        id: `${element.codetext}State`,
      };
    });
  }, [countriesList]);
  const { data: stateList } = useGetCodeTranslationQuery(
    { codetype: formik.values.Country },
    { skip: formik.values.Country !== 'IndiaState' }
  );

  let statesLists = useMemo(() => {
    if (!stateList) return [];
    return stateList.map((element) => {
      return {
        label: element.codetext,
        id: `${element.codetext}District`,
        statecode: element.statecode,
      };
    });
  }, [stateList]);
  const codetype1 = statesLists.filter((state) => formik.values.State && formik.values.State == state?.statecode)[0]?.id;
  const { data: districtList1 } = useGetCodeTranslationQuery({ codetype: codetype1 }, { skip: !formik.values.State });
  let districtsLists1 = useMemo(() => {
    if (!districtList1) return [];
    return districtList1.map((element) => {
      return {
        label: element.codetext,
        id: `${element.codetext}District`,
      };
    });
  }, [districtList1]);
  const codetype2 = statesLists.filter((state) => formik.values.StateD && formik.values.StateD == state?.statecode)[0]?.id;
  const { data: districtList2 } = useGetCodeTranslationQuery({ codetype: codetype2 }, { skip: !formik.values.StateD });
  let districtsLists2 = useMemo(() => {
    if (!districtList2) return [];
    return districtList2.map((element) => {
      return {
        label: element.codetext,
        id: `${element.codetext}District`,
      };
    });
  }, [districtList2]);
  useEffect(() => {
    if (
      (formik.values.gstCategory === 'UB' || formik.values.gstCategory === 'OC') &&
      customerState?.id === undefined &&
      partyParamsID === undefined
    ) {
      formik.setFieldValue('gstin', '');
    }
    if (formik.values.gstCategory === 'OC' && !customerState?.id && !partyParamsID) {
      formik.setFieldValue('pan', '');
      formik.setFieldValue('pos', '96');
    }
    if (
      formik.values.gstCategory !== 'OC' &&
      formik.values.gstCategory !== '' &&
      formik.errors.gstin !== '' &&
      gstApi === false &&
      !customerState?.id &&
      !partyParamsID
    ) {
      formik.setFieldValue('pos', '');
    }
  }, [formik.values.gstCategory]);

  const handlePan = async (e) => {
    const posData = Number(formik.values?.gstin?.substr(0, 2));
    try {
      if (formik.values.gstin.trim()?.length === 15 && formik.values.gstCategory !== 'OC') {
        setBackdropOpen(true);
        let fetchData = await FetchGstInDetails(formik.values.gstin);
        if (fetchData) {
          if (typeof posData === 'number' && !isNaN(posData)) {
            const place = pos?.filter((p) => p.statecode == posData);
            formik.setFieldValue('pos', place[0]?.statecode);
          }
          if (formik.values.gstCategory !== 'OC') {
            formik.setFieldValue('pan', formik.values.gstin.substring(2, 12));
            formik.setFieldTouched('pan', true, false);
          }
          const entityChar = formik.values?.gstin?.charAt(5);
          const entity = entityOptions.filter((ent) => ent?.panIdentifier === entityChar);
          formik.setFieldValue('entity', entity[0]?.id?.toString());
        }
        if (fetchData) {
          switch (fetchData?.data?.TaxPayerType) {
            case 'Regular':
              formik.setFieldValue('gstCategory', 'RBR');
              break;
            case 'SEZ Developer':
              formik.setFieldValue('gstCategory', 'SEZ');
              break;
            case 'SEZ Unit':
              formik.setFieldValue('gstCategory', 'SEZ');
              break;
            case 'Composition':
              formik.setFieldValue('gstCategory', 'RBCS');
              break;
            default:
              break;
          }

          if (setNewPartyName) {
            setNewPartyName(fetchData.data.TradeName);
          }
          formik.setFieldValue('Pincode', fetchData.data.Address.PinCode ?? '');
          formik.setFieldValue('legalName', fetchData.data.LegalName ?? '');
          formik.setFieldValue('legalShortName', fetchData.data.TradeName || fetchData.data.LegalName);
          formik.setFieldValue('billingAddress', fetchData.data.AddressTest ?? '');
          formik.setFieldValue('City', fetchData.data.Address.Location ?? '');
          setBool(false);
          try {
            if (fetchData.data.Address.PinCode?.length === 6) {
              let res = await LocationFetch(fetchData.data.Address.PinCode);
              const codetype = statesLists.filter((state) => state.id == `${res.State}District`)[0].statecode;
              formik.setFieldValue('State', codetype === 0 ? '' : codetype);
              formik.setFieldValue('District', `${res.District}District`);
            }
          } catch (err) {
            showWarningSnackbar('No data found for this pincode');
          }
        }
      }
    } catch (error) {
      showWarningSnackbar('GSTIN is NOT valid. Please recheck');
    } finally {
      setBackdropOpen(false);
    }
  };
  useEffect(() => {
    const gstApiCall = location.pathname.includes('view');

    if (formik.values?.gstin && formik.values?.gstin.trim()?.length === 15 && gstApiCall === false && gstApi) {
      handlePan();
    }
  }, [formik.values.gstin]);
  const upiChange = (value) => {
    setAnchorEl(null);
    if (value.includes('@')) {
      setAnchorEl(upiRef.current);
      const partial = value.split('@');
      const matches = upiHandles.filter((s) => s.includes(partial[1]));

      setShowSuggestions(true);
      if (matches.length > 0) {
        setFilteredSuggestions(matches);
      } else {
        setShowSuggestions(false);
      }
    } else {
      setShowSuggestions(false);
    }
  };
  const handleSuggestionClick = (suggestion) => {
    const lastAtIndex = formik.values.upi.lastIndexOf('@');
    if (lastAtIndex !== -1) {
      const newValue = formik.values.upi.slice(0, lastAtIndex) + '@' + suggestion;
      formik.setFieldValue('upi', newValue);
      setAnchorEl(null);
      setShowSuggestions(false);
    }
  };

  const handleClickAway = () => {
    setShowSuggestions(false);
  };

  const updateAttachmentName = (id, newName) => {
    setAttachments(
      attachments.map((attachment) => (attachment.attachmentid === id ? { ...attachment, documentname: newName } : attachment))
    );
  };
  console.log(formik.errors, 'errors');

  const activateThis = async (active) => {
    const sanitizedComments = formik.values.Comments.replace(/\n/g, ' ');
    setBackdropOpen(true);
    const partyCD = loc === true ? 'CUSTOMER' : 'SUPPLIER';
    const masterData = {
      partyid: customerData[0].partyid,
      companybranchid: customerData[0].companybranchid,
      sameaddressflag: bool === true ? 1 : 0,
      expiredtimestamp: 0,
      comments: sanitizedComments,
      partytypecd: partyCD,
      partydisplayname: formik.values.legalShortName,
      partylegalname: formik.values.legalName,
      groupaccountid: customerGroup === '' ? '0' : customerGroup,
      gstcategory: formik.values.gstCategory,
      placeofsupply: formik.values.pos,
      entity: formik.values.entity,
      email: `${formik.values.email}`,
      contactnumber: formik.values.contactNumber,
      whatsappnumber: formik.values.Whatsapp,
      accountsid: customerData[0].accountsid,
      is_active: customerData[0]?.is_active === 0 ? 1 : 0,
      msmetype: formik.values.msme,
      udhyamregno: formik.values.reg === '' ? '' : formik.values.reg,
      deliveryconsigneename: formik.values.ConsigneeName,
      deliveryconsigneegstin: formik.values.ConsigneeGSTIN === '' ? '' : formik.values.ConsigneeGSTIN,
      tdspercentage: formik.values.TDSPercentage,
      lastupdatedby: customerData[0]?.lastupdatedby,
      financialyearid: getCompany?.financialyearid,
      tdssection: formik.values.TDSSection === '' ? '' : formik.values.TDSSection,
    };
    const LedgerData = {
      accountgroupid: customerData[0].groupaccountid,
      accountname: customerData[0].partylegalname,
      accounttypecd: 'BS',
      accountsid: customerData[0].accountsid,
      companybranchid: userPreferece?.financialYear?.companybranchid,
      hsnsaccode: 0,
      is_active: customerData[0]?.is_active === 0 ? 1 : 0,
      accounttypeflag: loc === true ? 1 : 2,
    };
    try {
      const resledger = await API.graphql(
        graphqlOperation(updateAccountMaster, {
          updateAccountMasterInput: LedgerData,
        })
      );
      const resMaster = await API.graphql(
        graphqlOperation(createPartyMaster, {
          createPartyMasterInput: masterData,
        })
      );
      if (resMaster.data && customerData[0]?.is_active == 0) {
        showSuccessSnackbar(`${formik.values.legalShortName} marked as Active`);
      } else if (resMaster.data && customerData[0]?.is_active == 1) {
        showSuccessSnackbar(`${formik.values.legalShortName} marked as Inactive`);
      } else {
        showWarningSnackbar('Something went wrong');
      }
      getPartyMasterData(partyParamsID || customerState?.id);
      if (closePartyModal) {
        closePartyModal();
        dispatch(dashboardApi.util.invalidateTags(['dashboard']));
        dispatch(listAccountOpeningBalanceApi.util.invalidateTags(['listAccountOpeningBalance']));
        dispatch(listAccountMasterv2Api.util.invalidateTags(['listAccountMaster']));
        return;
      }

      if (active == 1 && !customerState.view && loc === true) {
        navigate('/customerList');
      } else if (active == 1 && !customerState.view && loc === false) {
        navigate('/supplierList');
      }
    } catch (error) {
      console.log(error, 'error');
      const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
      showWarningSnackbar(errorMessage);
    } finally {
      setBackdropOpen(false);
    }
  };

  let qrCodeData;
  const generateQRCode = async () => {
    if (isValidUPI(formik.values.upi)) {
      console.log(formik.values.upi, 'formik.values.upi');
      try {
        qrCodeData = await QRCode.toDataURL(`upi://pay?pa=${formik.values.upi}`);
        console.log(qrCodeData, 'qrCodeData');
        setQrupi(qrCodeData);
      } catch (error) {
        console.error('Error generating QR code', error);
      }
    } else {
      setQrupi('');
    }
  };
  useEffect(() => {
    generateQRCode();
  }, [formik.values.upi]);

  const saveChanges = async (e, obj) => {
    e?.preventDefault();
    formik.validateForm();
    const isPos96_create = String(formik.values.pos ?? '') === '96';
    const missingCountry_create = !formik.values.Country;
    const missingAddr_create = !String(formik.values.billingAddress || '').trim();
    if (isPos96_create && (missingCountry_create || missingAddr_create)) {
      if (missingCountry_create) {
        formik.setFieldTouched('Country', true, false);
        formik.setFieldError('Country', 'Please provide Country');
      }
      if (missingAddr_create) {
        formik.setFieldTouched('billingAddress', true, false);
        formik.setFieldError('billingAddress', 'Please provide billing address (Line 1)');
      }
      showWarningSnackbar('Please fill the highlighted fields');
      return;
    }
    let partyCD = loc === true ? 'CUSTOMER' : 'SUPPLIER';
    const sanitizedComments = formik.values.Comments?.trim();
    const entityname = formik.values.entity ? entityOptions.filter((ent) => ent?.id === formik.values.entity)[0].label : '';
    const boolCheck = bool === true ? 1 : 0;

    const partymasterjson = [
      {
        gstcategory: formik.values.gstCategory,
        entity: formik.values.entity,
        groupaccountid: customerGroup,
        partydisplayname: formik.values.legalShortName.trim(),
        partylegalname: formik.values.legalName.trim(),
        sameaddressflag: boolCheck,
        comments: sanitizedComments,
        partytypecd: partyCD,
        entityname,
        placeofsupply: formik.values.pos ? formik.values.pos : '',
        email: formik.values.email ? `${formik.values.email.trim()}` : '',
        contactnumber: contactNumber.Mobile !== '' ? contactNumber.Mobile.trim() : '',
        whatsappnumber: contactNumber.Whatsapp !== '' ? contactNumber.Whatsapp : '',
        is_active: 1,
        deliveryconsigneename: formik.values.ConsigneeName.trim(),
        deliveryconsigneegstin: formik.values.ConsigneeGSTIN === '' ? '' : formik.values.ConsigneeGSTIN.trim(),
        contactcountry: contactNumber.MobileIso,
        whatsappcountry: contactNumber.WhatsappIso,
        msmetype: formik.values.msme ? formik.values.msme.trim() : '',
        tdspercentage: formik.values.TDSPercentage ? Number(formik.values.TDSPercentage.trim()) : 0.0,
        udhyamregno: formik.values.reg ? formik.values.reg.trim() : '',
        tdssection: formik.values.TDSSection,
      },
    ];

    const PartyAddressEntityarrayofjson = [
      {
        city: formik.values.City.trim(),
        countrycode: formik.values.Country.trim(),
        line1: formik.values?.billingAddress ? formik.values?.billingAddress?.trim() : '',
        line2: '',
        line3: '',
        objecttype: 'PartyBilling',
        foreignstate: formik.values.foreignstate,
        foreigndistrict: formik.values.foreigndistrict,
        pincode: formik.values.Pincode,
        statecode: formik.values.State ? Number(formik.values.State) : 0,
        district: formik.values.District,
        consigneename: formik.values.legalName.trim(),
        consigneegstin: formik.values.gstin,
      },
      {
        city: formik.values.CityD.trim(),
        countrycode: formik.values.CountryD.trim(),
        line1: formik.values?.billingAddressD ? formik.values?.billingAddressD?.trim() : '',
        line2: '',
        line3: '',
        foreignstate: formik.values.foreignstateD,
        foreigndistrict: formik.values.foreigndistrictD,
        objecttype: 'PartyDelivery',
        pincode: formik.values.PincodeD,
        statecode: formik.values.StateD ? Number(formik.values.StateD) : 0,
        district: formik.values.DistrictD,
        consigneename: formik.values.ConsigneeName.trim(),
        consigneegstin: formik.values.ConsigneeGSTIN === '' ? '' : formik.values.ConsigneeGSTIN.trim(),
      },
    ];
    const filteredAddresses = PartyAddressEntityarrayofjson.filter((obj) => {
      // exclude objecttype, line2, line3 from check
      const { objecttype, line2, line3, ...rest } = obj;

      return Object.values(rest).some((val) => {
        if (typeof val === 'string') {
          return val.trim() !== '';
        }
        return val !== null && val !== 0; // for numbers
      });
    });
    const PartyContactarrayofjson = [
      {
        contactdesignationname: formik.values.Designation.trim(),
        contactorder: 3,
        contactcountry: contactPerson.MobileIso,
        whatsappcountry: contactPerson.WhatsappIso,
        contacttypename: formik.values.fullname.trim(),
        email: formik.values.email.trim(),
        phonenumber: contactPerson.Mobile !== '' ? contactPerson.Mobile.trim() : '',
        whatsappnumber: contactPerson.Whatsapp !== '' ? contactPerson.Whatsapp : '',
      },
    ];

    const PartyCreditDetailsarrayofjson = [
      {
        billwiseflag: linkRecipt === false ? 0 : 1,
        billingcurrency: formik.values.billingCurrency ? Number(formik.values.billingCurrency) : 0,
        creditlimitamount: formik.values.creditLimit === '' ? 0 : Number(formik.values.creditLimit?.toString()?.replace(/,/g, '')),
        creditlimitcd: 6,
        creditperiodduration: formik.values.creditPeriod === '' ? 0 : Number(formik.values.creditPeriod),
        notes: formik.values.notes ? formik.values.notes.trim() : '',
      },
    ];

    const PartyGSTDetailsarrayofjson = [
      {
        gstin: formik.values.gstin,
        pannumber: formik.values.pan,
        partyaddressid: 6,
      },
    ];
    const PartyImagesarrayofjson = attachments.map((att) => {
      const attType = att.type.split('/')[1];
      const name = att.imagename.replace(/\.[^/.]+$/, '').split('/')[0];

      return {
        type: attType,
        imagename: att.imagename,
        documentname: att.documentname,
        imageurl: att.imageurl.startsWith('https:') ? att.imageurl : `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${att.imagename}`,
      };
    });
    const BankDetailsarrayofjson = [
      {
        objecttype: 'Supplier',
        bankname: formik.values.bankName.trim(),
        bankaccountnumber: formik.values.bankAC.trim(),
        ifsccode: formik.values.ifsc.trim(),
        branch: formik.values.branch.trim(),
        notes: formik.values.notes ? formik.values.notes.trim() : '',
        ledgeraccount: '',
        bankaccounttype: '',
        accountgroupid: 0,
        cash: formik.values.cash ? formik.values.cash : 0,
        swiftcode: formik.values.swiftcode.trim(),
        upi: formik.values.upi,
      },
    ];

    const partytabledatacollection = {
      partymaster: partymasterjson,
      partyaddressentity: filteredAddresses,
      partycontact: PartyContactarrayofjson,
      partycreditdetails: PartyCreditDetailsarrayofjson,
      partygstdetails: PartyGSTDetailsarrayofjson,
      partyimages: PartyImagesarrayofjson,
      bankdetails: BankDetailsarrayofjson,
      accountsid: accountId ? accountId : null,
    };
    const errors = await formik.validateForm(formik.values);

    const { gstin, ...newObj } = errors;
    if (Object.keys(newObj).length !== 0) {
      const labels = Object.keys(newObj).map(humanizeKey);
      showWarningSnackbar('Please fill ' + labels.map((g) => ' ' + g));
    }
    if (errors?.gstCategory && catref.current) {
      catref.current.focus();
    } else if (
      (formik.values.gstin.trim() !== '' && formik.values.gstin.trim()?.length < 15) ||
      formik.errors.gstin === 'GSTIN is required.'
    ) {
      gstref.current.focus();
      showWarningSnackbar('Please provide valid GSTIN');
    } else if (errors?.pan && panref.current) {
      panref.current.focus();
    } else if (errors?.legalName && legalref.current) {
      legalref.current.focus();
    } else if (errors?.legalShortName && shortref.current) {
      shortref.current.focus();
    } else if (errors?.entity && entityref.current) {
      entityref.current.focus();
    } else if (contactNumber.errorFields.Mobile && contactref.current) {
      showWarningSnackbar('Please fill the highlighted fields');
      contactref.current.focus();
      return;
    } else if (contactNumber.errorFields.Whatsapp && whatsappref1.current) {
      showWarningSnackbar('Please fill the highlighted fields');
      whatsappref1.current.focus();
      return;
    } else if (contactPerson.errorFields.Mobile && mobileref.current) {
      showWarningSnackbar('Please fill the highlighted fields');
      mobileref.current.focus();
      return;
    } else if (contactPerson.errorFields.Whatsapp && whatsappref2.current) {
      showWarningSnackbar('Please fill the highlighted fields');
      whatsappref2.current.focus();
      return;
    }
    try {
      if (loc === true) {
        if (
          (Object.keys(newObj).length === 0 && formik.values.gstin.trim() === '' && formik.errors.gstin !== 'GSTIN is required.') ||
          (formik.values.gstin.trim() !== '' &&
            formik.values.gstin.trim().length === 15 &&
            Object.keys(newObj).length === 0 &&
            formik.errors.gstin !== 'GSTIN is required.')
        ) {
          console.log(partytabledatacollection, 'partytabledatacollection');

          setBackdropOpen(true);
          const resPartyTransaction = await API.graphql(
            graphqlOperation(createPartyTransaction, {
              createPartyTransactionInput: partytabledatacollection,
            })
          );

          showSuccessSnackbar('Customer Created Successfully');

          if (passFn) passFn();
          let responses = attachments.map((element) => {
            return uploadToServer(
              element.file,
              element.imagename.replace('${id}', resPartyTransaction.data.createPartyTransaction.partyid),
              element.type
            );
          });
          let response = await Promise.all(responses);

          if (obj.new === true) {
            // showSuccessSnackbar("Customer added. Please add new customer");
            formik.resetForm({ values: initialValues });
            setResetBool((c) => c + 1);
            // Delay slightly to ensure reset is applied before triggering validation
            setTimeout(() => {
              formik.validateForm().then((errors) => {
                formik.setErrors(errors);
              });
            }, 0);
            setLinkRecipt(false);
            setBool(true);
            setAttachments([]);
            setCustomerGroup(15);
          } else {
            if (closePartyModal) {
              setNewPartyID(resPartyTransaction.data.createPartyTransaction.partyid);

              if (setNewPartyName) {
                setNewPartyName(formik.values.legalName.trim());
              }
              if (listPartyDetails) {
                listPartyDetails(resPartyTransaction.data.createPartyTransaction.partyid);
              }
              closePartyModal(false, 'force');
            } else {
              navigate('/customerList', { force: true });
            }
          }
          onSave({
            accountsId: resPartyTransaction.data.createPartyTransaction?.accountid,
            partyId: resPartyTransaction.data.createPartyTransaction?.partyid,
          });

          dispatch(listAccountMasterv2Api.util.invalidateTags(['listAccountMaster']));
          setBackdropOpen(false);
        }
      }

      if (loc === false) {
        if (
          (Object.keys(newObj).length === 0 && formik.values.gstin.trim() === '') ||
          (formik.values.gstin.trim() !== '' && formik.values.gstin.trim().length === 15 && Object.keys(newObj).length === 0)
        ) {
          setBackdropOpen(true);
          const resPartyTransaction = await API.graphql(
            graphqlOperation(createPartyTransaction, {
              createPartyTransactionInput: partytabledatacollection,
            })
          );

          showSuccessSnackbar('Supplier Created Successfully');

          if (passFn) passFn();
          let responses = attachments.map((element) => {
            return uploadToServer(
              element.file,
              element.imagename.replace('${id}', resPartyTransaction.data.createPartyTransaction.partyid),
              element.type
            );
          });
          let response = await Promise.all(responses);
          console.log('obj.new ', obj.new, partyType);
          if (obj.new === true) {
            formik.resetForm({ values: initialValues });
            setResetBool((c) => c + 1);
            // Delay slightly to ensure reset is applied before triggering validation
            setTimeout(() => {
              formik.validateForm().then((errors) => {
                formik.setErrors(errors);
              });
            }, 0);
            setLinkRecipt(false);
            setBool(true);
            setAttachments([]);
            setCustomerGroup(7);
          } else {
            if (closePartyModal) {
              setNewPartyID(resPartyTransaction.data.createPartyTransaction.partyid);
              if (listPartyDetails) {
                listPartyDetails(resPartyTransaction.data.createPartyTransaction.partyid);
              }
              if (setNewPartyName) {
                setNewPartyName(formik.values.legalName.trim());
              }
              closePartyModal(false, 'force');
            } else {
              navigate('/supplierList', { force: true });
            }
          }
          onSave({
            accountsId: resPartyTransaction.data.createPartyTransaction?.accountid,
            partyId: resPartyTransaction.data.createPartyTransaction?.partyid,
          });
          dispatch(listAccountMasterv2Api.util.invalidateTags(['listAccountMaster']));
        }

        setBackdropOpen(false);
      }
      if (accountId) {
        dispatch(listAccountMasterv3Api.util.invalidateTags(['partyDetailsByAccountId', 'listAccountMaster']));
      }
      dispatch(dashboardApi.util.invalidateTags(['dashboard']));
      dispatch(listAccountOpeningBalanceApi.util.invalidateTags(['listAccountOpeningBalance']));
      if (customModal) {
        dispatch(setModalBlocked(false));
      } else {
        dispatch(setNavigationBlocked(false));
      }
    } catch (err) {
      const rawMessage = err.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
      setBackdropOpen(false);
      showWarningSnackbar(errorMessage);
    } finally {
      if (customModal) {
        dispatch(setModalBlocked(false));
      } else {
        dispatch(setNavigationBlocked(false));
      }
      setBackdropOpen(false);
    }
  };
  console.log(formik.values, 'hhhhhhhhhhhh');

  //////*******************update Customer*************** */
  async function saveEditChanges() {
    try {
      const isPos96_edit = String(formik.values.pos ?? '') === '96';
      const missingCountry_edit = !formik.values.Country;
      const missingAddr_edit = !String(formik.values.billingAddress || '').trim();
      if (isPos96_edit && (missingCountry_edit || missingAddr_edit)) {
        if (missingCountry_edit) {
          formik.setFieldTouched('Country', true, false);
          formik.setFieldError('Country', 'Please provide Country');
        }
        if (missingAddr_edit) {
          formik.setFieldTouched('billingAddress', true, false);
          formik.setFieldError('billingAddress', 'Please provide billing address (Line 1)');
        }
        showWarningSnackbar('Please fill the highlighted fields');
        return;
      }
      const partyCD = loc === true ? 'CUSTOMER' : 'SUPPLIER';
      const LedgerData = {
        accountgroupid: customerGroup,
        accountname: formik.values.legalShortName.trim(),
        accounttypecd: 'BS',
        accountsid: customerData[0].accountsid,
        companybranchid: 0,
        hsnsaccode: 0,
        is_active: 1,
        accounttypeflag: loc === true ? 1 : 2,
      };
      const entityname = formik.values.entity ? entityOptions.filter((ent) => ent?.id === formik.values.entity)[0].label : '';
      // const sanitizedComments = formik.values.Comments.replace(/\n/g, " ");
      const sanitizedComments = formik.values.Comments.trim();
      const boolCheck = bool === true ? 1 : 0;
      const masterData = {
        partyid: customerData[0].partyid,
        // companyid: getCompany?.companyid,
        companybranchid: userPreferece?.financialYear?.companybranchid,
        expiredtimestamp: 0,
        entityname,
        partytypecd: partyCD,
        contactcountry: contactNumber.MobileIso,
        whatsappcountry: contactNumber.WhatsappIso,
        sameaddressflag: boolCheck,
        comments: sanitizedComments,
        partydisplayname: formik.values.legalShortName.trim(),
        partylegalname: formik.values.legalName.trim(),
        groupaccountid: customerGroup === '' ? '0' : customerGroup,
        gstcategory: formik.values.gstCategory,
        placeofsupply: formik.values.pos,
        entity: formik.values.entity,
        email: `${formik.values.email.trim()}`,
        contactnumber: contactNumber.Mobile !== '' ? contactNumber.Mobile.trim() : '',
        whatsappnumber: contactNumber.Whatsapp !== '' ? contactNumber.Whatsapp : '',
        accountsid: customerData[0].accountsid,
        is_active: 1,
        lastupdatedby: getCompany?.lastupdatedby,
        deliveryconsigneename: formik.values.ConsigneeName.trim(),
        deliveryconsigneegstin: formik.values.ConsigneeGSTIN === '' ? '' : formik.values.ConsigneeGSTIN.trim(),

        udhyamregno: formik.values.reg === '' ? '' : formik.values.reg.trim(),
        msmetype: formik.values.msme === '' ? '' : formik.values.msme.trim(),
        tdspercentage: formik.values.TDSPercentage ? formik.values.TDSPercentage : 0.0,
        financialyearid: getCompany?.financialyearid,
        tdssection: formik.values.TDSSection === '' || !formik.values.TDSSection ? '' : formik.values.TDSSection,
      };
      const expBill = dayjs().startOf('day').unix();
      const expBillBool =
        formik.values.City !== '' ||
        formik.values.Country !== '' ||
        formik.values?.billingAddress !== '' ||
        formik.values.Pincode ||
        formik.values.State !== '' ||
        formik.values.District !== '';
      const billingAddressEntity = {
        city: formik.values.City ? formik.values.City.trim() : '',
        countrycode: formik.values.Country.trim(),
        line1: formik.values?.billingAddress ? formik.values?.billingAddress?.trim() : '',
        line2: '',
        line3: '',
        expiredtimestamp: expBillBool ? 0 : expBill,
        objectid: customerData[0]?.partyid,
        objecttype: 'PartyBilling',
        foreignstate: '',
        foreigndistrict: '',
        pincode: formik.values.Pincode ? formik.values.Pincode?.trim() : '',
        statecode: formik.values.State ? Number(formik.values.State) : 0,
        district: formik.values.District ? formik.values.District?.trim() : '',
        consigneename: formik.values.legalName.trim(),
        consigneegstin: formik.values.gstin,
        financialyearid: userPreferece?.financialYear?.financialyearid,
      };
      const expDelBool =
        formik.values.CityD !== '' ||
        formik.values.CountryD !== '' ||
        formik.values?.billingAddressD !== '' ||
        formik.values.PincodeD ||
        formik.values.StateD !== '' ||
        formik.values.DistrictD !== '';
      const deliveryAddressEntity = {
        city: formik.values.CityD ? formik.values.CityD?.trim() : '',
        countrycode: formik.values.CountryD,
        line1: formik.values?.billingAddressD ? formik.values?.billingAddressD?.trim() : '',
        line2: '',
        line3: '',
        expiredtimestamp: expDelBool ? 0 : expBill,
        objectid: customerData[0].partyid,
        foreignstate: '',
        foreigndistrict: '',
        objecttype: 'PartyDelivery',
        pincode: formik.values.PincodeD ? formik.values.PincodeD?.trim() : '',
        statecode: formik.values.StateD ? Number(formik.values.StateD) : 0,
        district: formik.values.DistrictD ? formik.values.DistrictD?.trim() : '',
        consigneename: formik.values.ConsigneeName.trim(),
        consigneegstin: formik.values.ConsigneeGSTIN === '' ? '' : formik.values.ConsigneeGSTIN.trim(),
        financialyearid: userPreferece?.financialYear?.financialyearid,
      };

      const updateContacts = {
        partyid: customerData[0].partyid,
        expiredtimestamp: 0,
        contacttypename: formik.values.fullname.trim(),
        phonenumber: contactPerson.Mobile !== '' ? contactPerson.Mobile.trim() : '',
        whatsappnumber: contactPerson.Whatsapp !== '' ? contactPerson.Whatsapp : '',
        contactdesignationname: formik.values.Designation.trim(),
        contactorder: 3,
        email: formik.values.EmailContact.trim(),
        contactcountry: contactPerson.MobileIso,
        whatsappcountry: contactPerson.WhatsappIso,
      };
      const creditData = {
        partyid: customerData[0].partyid,
        billwiseflag: linkRecipt === false ? 0 : 1,
        billingcurrency: formik.values.billingCurrency,
        creditlimitamount: formik.values.creditLimit === '' ? 0 : formik.values.creditLimit?.toString()?.replace(/,/g, ''),
        creditlimitcd: 6,
        creditperiodduration: formik.values.creditPeriod === '' ? 0 : formik.values.creditPeriod,
        notes: formik.values.notes ? formik.values.notes.trim() : '',
      };

      const gstData = {
        gstin: formik.values.gstin,
        pannumber: formik.values.pan,
        partyaddressid: 6,
        partyid: customerData[0].partyid,
      };

      const errors = await formik.validateForm(formik.values);
      const { gstin, ...newObj } = errors;
      const labels = Object.keys(newObj).map(humanizeKey);
      if (Object.keys(newObj).length !== 0 && formik.errors.gstin !== 'GSTIN is required.') {
        showWarningSnackbar('Please fill ' + labels.map((g) => ' ' + g));
        // showWarningSnackbar('Please fill the highlighted fields');
      }
      if (errors?.gstCategory && catref.current) {
        catref.current.focus();
      } else if (
        (formik.values.gstin.trim() !== '' && formik.values.gstin.trim()?.length < 15) ||
        formik.errors.gstin === 'GSTIN is required.'
      ) {
        gstref.current.focus();
        showWarningSnackbar('Please provide valid GSTIN');
      } else if (errors?.pan && panref.current) {
        panref.current.focus();
      } else if (errors?.legalName && legalref.current) {
        legalref.current.focus();
      } else if (errors?.legalShortName && shortref.current) {
        shortref.current.focus();
      } else if (errors?.entity && entityref.current) {
        entityref.current.focus();
      } else if (contactNumber.errorFields.Mobile && contactref.current) {
        showWarningSnackbar('Please fill the highlighted fields');
        contactref.current.focus();
        return;
      } else if (contactNumber.errorFields.Whatsapp && whatsappref1.current) {
        showWarningSnackbar('Please fill the highlighted fields');
        whatsappref1.current.focus();
        return;
      } else if (contactPerson.errorFields.Mobile && mobileref.current) {
        showWarningSnackbar('Please fill the highlighted fields');
        mobileref.current.focus();
        return;
      } else if (contactPerson.errorFields.Whatsapp && whatsappref2.current) {
        showWarningSnackbar('Please fill the highlighted fields');
        whatsappref2.current.focus();
        return;
      }
      const hasReqError = formik.errors.gstin === 'GSTIN is required.';
      if (loc === true) {
        if (
          (formik.values.gstin.trim() !== '' && formik.values.gstin.trim().length === 15 && Object.keys(newObj).length === 0) ||
          (formik.values.gstin.trim() === '' && formik.errors.gstin !== 'GSTIN is required.' && Object.keys(newObj).length === 0)
        ) {
          setBackdropOpen(true);
          if (
            customerData[0].partydisplayname !== formik.values.legalShortName ||
            customerData[0].partylegalname !== formik.values.legalName ||
            customerData[0].groupaccountid !== customerGroup ||
            customerData[0].gstcategory !== formik.values.gstCategory ||
            customerData[0].placeofsupply !== formik.values.pos ||
            customerData[0].entity !== formik.values.entity ||
            customerData[0].email !== formik.values.email ||
            customerData[0].contactnumber !== formik.values.contactNumber ||
            customerData[0].whatsappnumber !== formik.values.Whatsapp ||
            customerData[0].sameaddressflag !== boolCheck ||
            customerData[0].contactcountry !== contactNumber?.MobileIso ||
            customerData[0].whatsappcountry !== contactNumber?.WhatsappIso ||
            customerData[0].deliveryconsigneename !== formik.values.ConsigneeName ||
            customerData[0].deliveryconsigneegstin !== formik.values.ConsigneeGSTIN ||
            customerData[0].comments !== sanitizedComments
          ) {
            const resMaster = await API.graphql(
              graphqlOperation(createPartyMaster, {
                createPartyMasterInput: masterData,
              })
            );
          }
          if (billingAddress?.length > 0) {
            if (
              billingAddress[0]?.city !== formik.values.City ||
              billingAddress[0]?.countrycode !== formik.values.Country ||
              billingAddress[0]?.line1 !== formik.values.billingAddress ||
              billingAddress[0]?.pincode !== formik.values.Pincode ||
              billingAddress[0]?.district !== formik.values.District
            ) {
              const resPartyBillingAddressEntity = await API.graphql(
                graphqlOperation(createPartyAddressEntity, {
                  createPartyAddressEntityInput: [billingAddressEntity],
                })
              );
            }
          }

          if (deliveryAddress?.length) {
            if (
              deliveryAddress[0]?.city !== formik.values.CityD ||
              deliveryAddress[0]?.countrycode !== formik.values.CountryD ||
              deliveryAddress[0]?.line1 !== formik.values.billingAddressD ||
              deliveryAddress[0]?.pincode !== formik.values.PincodeD ||
              deliveryAddress[0]?.state !== formik.values.StateD ||
              deliveryAddress[0]?.district !== formik.values.DistrictD ||
              deliveryAddress[0]?.consigneename !== formik.values.ConsigneeName.trim() ||
              deliveryAddress[0]?.consigneegstin !== formik.values.ConsigneeGSTIN.trim()
            ) {
              const resPartyDeliveryAddressEntity = await API.graphql(
                graphqlOperation(createPartyAddressEntity, {
                  createPartyAddressEntityInput: [deliveryAddressEntity],
                })
              );
            }
          } else if (
            formik.values.CityD ||
            formik.values.CountryD ||
            formik.values.billingAddressD ||
            formik.values.PincodeD ||
            formik.values.DistrictD ||
            formik.values.ConsigneeName.trim() ||
            formik.values.ConsigneeGSTIN.trim()
          ) {
            const resPartyDeliveryAddressEntity = await API.graphql(
              graphqlOperation(createPartyAddressEntity, {
                createPartyAddressEntityInput: [deliveryAddressEntity],
              })
            );
          }
          if (
            customerData[0].relatedpartycontact[0].contacttypename !== formik.values.fullname ||
            customerData[0].relatedpartycontact[0].contactdesignationname !== formik.values.Designation ||
            customerData[0].relatedpartycontact[0].email !== formik.values.EmailContact ||
            customerData[0].relatedpartycontact[0].phonenumber !== formik.values.Mobile ||
            customerData[0].relatedpartycontact[0].whatsappnumber !== formik.values.WhatsappContact ||
            customerData[0].relatedpartycontact[0].contactcountry !== contactPerson.MobileIso ||
            customerData[0].relatedpartycontact[0].whatsappcountry !== contactPerson.WhatsappIso
          ) {
            const updateResContact = await API.graphql(
              graphqlOperation(createPartyContact, {
                createPartyContactInput: [updateContacts],
              })
            );
          }
          if (customerData[0].partylegalname !== formik.values.legalName || customerData[0].groupaccountid !== customerGroup) {
            const resledger = await API.graphql(
              graphqlOperation(updateAccountMaster, {
                updateAccountMasterInput: LedgerData,
              })
            );
          }
          const billFlag = linkRecipt === false ? 0 : 1;
          if (
            customerData[0].relatedpartycreditdetails[0].billwiseflag !== billFlag ||
            customerData[0].relatedpartycreditdetails[0].billingcurrency !== formik.values.billingCurrency ||
            customerData[0].relatedpartycreditdetails[0].creditlimitamount !==
              Number(formik.values.creditLimit.toString()?.replace(/,/g, '')) ||
            customerData[0].relatedpartycreditdetails[0].creditperiodduration !== formik.values.creditPeriod ||
            customerData[0].relatedpartycreditdetails[0].notes !== formik.values.notes
          ) {
            const resCredit = await API.graphql(
              graphqlOperation(createPartyCreditDetails, {
                createPartyCreditDetailsInput: creditData,
              })
            );
          }
          if (
            customerData[0].relatedpartygstdetails[0].gstin !== formik.values.gstin ||
            customerData[0].relatedpartygstdetails[0].pannumber !== formik.values.pan
          ) {
            const resGST = await API.graphql(
              graphqlOperation(createPartyGSTDetails, {
                createPartyGSTDetailsInput: gstData,
              })
            );
          }
          Math.floor(new Date().getTime() / 1000);
          const exp = Math.floor(new Date().getTime() / 1000);
          const idsInArray2 = new Set(attachments.map((item) => item.attachmentid));

          let arratt = [];
          const updatedArray1 = currentDocuments.map((item) => {
            let arr;
            if (!idsInArray2.has(item.attachmentid) && typeof item.attachmentid !== 'string') {
              arr = { ...item, expiredtimestamp: exp };
              arratt.push(arr);
            } else {
              // arr = attachments[item.attachmentid] || item;
              arr = attachments.find((att) => att.attachmentid === item.attachmentid);
              arratt.push(arr);
            }
          });

          const additionalItems = attachments.filter(
            (item2) => !currentDocuments.some((item1) => item1.attachmentid == item2.attachmentid)
          );

          const finalArray = [...arratt, ...additionalItems];
          let responses = [];
          const attachedArr = finalArray.map((ele, ind) => {
            if (ele.file) {
              responses.push(uploadToServer(ele.file, ele.imagename.replace('${id}', customerData[0]?.partyid), ele.type));
            }

            return {
              imagename: ele.imagename.replace('${id}', customerData[0]?.partyid),
              imageurl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename.replace('${id}', customerData[0]?.partyid)}`,
              partyid: customerData[0]?.partyid,
              documentname: ele.documentname.trim(),
              type: ele?.type,
              expiredtimestamp: ele.expiredtimestamp ? ele.expiredtimestamp : 0,
              attachmentid: typeof ele.attachmentid === 'string' ? 0 : ele.attachmentid,
            };
          });
          let response = await Promise.all(responses);
          console.log(attachedArr, 'attachedArr');
          if (attachedArr.length > 0) {
            const reseditimg = await API.graphql(
              graphqlOperation(createPartyImages, {
                createPartyImagesInput: attachedArr,
              })
            );
          }
          if (partyType === 'customer') {
            if (setNewPartyID) {
              setNewPartyID(customerData[0]?.partyid);
            }
            if (listPartyDetails) {
              listPartyDetails(customerData[0]?.partyid);
            }
            if (setNewPartyName) {
              setNewPartyName(formik.values.legalName.trim());
            }
            closePartyModal(false, 'force');
          } else {
            navigate('/customerList', { force: true });
          }
          dispatch(listAccountMasterv2Api.util.invalidateTags(['listAccountMaster']));
          showSuccessSnackbar('Customer Updated Successfully');
        }
      } else {
        if (
          (Object.keys(newObj).length === 0 && formik.values.gstin.trim() === '') ||
          (formik.values.gstin.trim() !== '' && formik.values.gstin.trim().length === 15 && Object.keys(newObj).length === 0)
        ) {
          setBackdropOpen(true);
          if (customerData[0].partylegalname !== formik.values.legalName || customerData[0].groupaccountid !== customerGroup) {
            const resledger = await API.graphql(
              graphqlOperation(updateAccountMaster, {
                updateAccountMasterInput: LedgerData,
              })
            );
          }
          if (
            customerData[0].partydisplayname !== formik.values.legalShortName ||
            customerData[0].partylegalname !== formik.values.legalName ||
            customerData[0].groupaccountid !== customerGroup ||
            customerData[0].gstcategory !== formik.values.gstCategory ||
            customerData[0].placeofsupply !== formik.values.pos ||
            customerData[0].entity !== formik.values.entity ||
            customerData[0].email !== formik.values.email ||
            customerData[0].contactnumber !== formik.values.contactNumber ||
            customerData[0].whatsappnumber !== formik.values.Whatsapp ||
            customerData[0].contactcountry !== contactNumber?.MobileIso ||
            customerData[0].whatsappcountry !== contactNumber?.WhatsappIso ||
            customerData[0].deliveryconsigneename !== formik.values.ConsigneeName ||
            customerData[0].deliveryconsigneegstin !== formik.values.ConsigneeGSTIN ||
            customerData[0].udhyamregno !== formik.values.reg ||
            customerData[0].msmetype !== formik.values.msme ||
            customerData[0].tdspercentage !== formik.values.TDSPercentage
          ) {
            const resMaster = await API.graphql(
              graphqlOperation(createPartyMaster, {
                createPartyMasterInput: masterData,
              })
            );
          }
          if (
            customerData[0].relatedpartygstdetails[0].gstin !== formik.values.gstin ||
            customerData[0].relatedpartygstdetails[0].pannumber !== formik.values.pan
          ) {
            const resGST = await API.graphql(
              graphqlOperation(createPartyGSTDetails, {
                createPartyGSTDetailsInput: gstData,
              })
            );
          }
          const billFlag = linkRecipt === false ? 0 : 1;
          if (
            customerData[0].relatedpartycreditdetails[0].billwiseflag !== billFlag ||
            customerData[0].relatedpartycreditdetails[0].billingcurrency !== formik.values.billingCurrency ||
            customerData[0].relatedpartycreditdetails[0].creditlimitamount !==
              Number(formik.values.creditLimit?.toString()?.replace(/,/g, '')) ||
            customerData[0].relatedpartycreditdetails[0].creditperiodduration !== formik.values.creditPeriod ||
            customerData[0].relatedpartycreditdetails[0].notes !== formik.values.notes
          ) {
            const resCredit = await API.graphql(
              graphqlOperation(createPartyCreditDetails, {
                createPartyCreditDetailsInput: creditData,
              })
            );
          }
          if (
            customerData[0].relatedpartycontact[0].contacttypename !== formik.values.fullname ||
            customerData[0].relatedpartycontact[0].contactdesignationname !== formik.values.Designation ||
            customerData[0].relatedpartycontact[0].email !== formik.values.EmailContact ||
            customerData[0].relatedpartycontact[0].phonenumber !== formik.values.Mobile ||
            customerData[0].relatedpartycontact[0].whatsappnumber !== formik.values.WhatsappContact
          ) {
            const updateResContact = await API.graphql(
              graphqlOperation(createPartyContact, {
                createPartyContactInput: [updateContacts],
              })
            );
          }
          if (billingAddress && billingAddress?.length > 0) {
            if (
              billingAddress[0].city !== formik.values.City ||
              billingAddress[0].countrycode !== formik.values.Country ||
              billingAddress[0].line1 !== formik.values.billingAddress ||
              billingAddress[0].pincode !== formik.values.Pincode ||
              billingAddress[0].statecode !== Number(formik.values.State || 0) ||
              billingAddress[0].district !== formik.values.District
            ) {
              const resPartyBillingAddressEntity = await API.graphql(
                graphqlOperation(createPartyAddressEntity, {
                  createPartyAddressEntityInput: [billingAddressEntity],
                })
              );
            }
          }

          if (deliveryAddress?.length) {
            if (
              deliveryAddress[0]?.city !== formik.values.CityD ||
              deliveryAddress[0]?.countrycode !== formik.values.CountryD ||
              deliveryAddress[0]?.line1 !== formik.values.billingAddressD ||
              deliveryAddress[0]?.pincode !== formik.values.PincodeD ||
              deliveryAddress[0]?.district !== formik.values.DistrictD ||
              deliveryAddress[0]?.consigneename !== formik.values.ConsigneeName.trim() ||
              deliveryAddress[0]?.consigneegstin !== formik.values.ConsigneeGSTIN.trim()
            ) {
              const resPartyDeliveryAddressEntity = await API.graphql(
                graphqlOperation(createPartyAddressEntity, {
                  createPartyAddressEntityInput: [deliveryAddressEntity],
                })
              );
            }
          } else if (
            formik.values.CityD ||
            formik.values.CountryD ||
            formik.values.billingAddressD ||
            formik.values.PincodeD ||
            formik.values.DistrictD ||
            formik.values.ConsigneeName.trim() ||
            formik.values.ConsigneeGSTIN.trim()
          ) {
            const resPartyDeliveryAddressEntity = await API.graphql(
              graphqlOperation(createPartyAddressEntity, {
                createPartyAddressEntityInput: [deliveryAddressEntity],
              })
            );
          }

          Math.floor(new Date().getTime() / 1000);
          const exp = Math.floor(new Date().getTime() / 1000);
          const idsInArray2 = new Set(attachments.map((item) => item.attachmentid));

          let arratt = [];
          const updatedArray1 = currentDocuments.map((item) => {
            let arr;
            if (!idsInArray2.has(item.attachmentid) && typeof item.attachmentid !== 'string') {
              arr = { ...item, expiredtimestamp: exp };
              arratt.push(arr);
            } else {
              // arr = attachments[item.attachmentid] || item;
              arr = attachments.find((att) => att.attachmentid === item.attachmentid);
              arratt.push(arr);
            }
          });

          const additionalItems = attachments.filter(
            (item2) => !currentDocuments.some((item1) => item1.attachmentid == item2.attachmentid)
          );

          const finalArray = [...arratt, ...additionalItems];
          let responses = [];
          const attachedArr = finalArray.map((ele, ind) => {
            if (ele.file) {
              responses.push(uploadToServer(ele.file, ele.imagename.replace('${id}', customerData[0]?.partyid), ele.type));
            }
            return {
              imagename: ele.imagename.replace('${id}', customerData[0]?.partyid),
              imageurl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename.replace('${id}', customerData[0]?.partyid)}`,
              partyid: customerData[0]?.partyid,
              documentname: ele.documentname.trim(),
              type: ele?.type,
              expiredtimestamp: ele.expiredtimestamp ? ele.expiredtimestamp : 0,
              attachmentid: typeof ele.attachmentid === 'string' ? 0 : ele.attachmentid,
            };
          });
          let response = await Promise.all(responses);
          if (attachedArr.length > 0) {
            const reseditimg = await API.graphql(
              graphqlOperation(createPartyImages, {
                createPartyImagesInput: attachedArr,
              })
            );
          }
          if (bankData) {
            if (
              bankData.bankaccountnumber !== formik.values.bankAC ||
              bankData.bankname !== formik.values.bankName ||
              bankData.branch !== formik.values.branch ||
              bankData.ifsccode !== formik.values.ifsc ||
              bankData.cash !== Number(formik.values.cash?.toString()?.replace(/,/g, '')) ||
              bankData.swiftcode !== formik.values.swiftcode
            ) {
              const updateBank = {
                bankaccountnumber: formik.values.bankAC.trim(),
                bankdetailsid: bankData[0]?.bankdetailsid,
                companybranchid: bankData[0].companybranchid,
                bankname: formik.values.bankName.trim(),
                branch: formik.values.branch.trim(),
                expiredtimestamp: 0,
                ifsccode: formik.values.ifsc.trim(),
                notes: formik.values.notes ? formik.values.notes.trim() : '',
                objectid: bankData[0].objectid,
                objecttype: 'Supplier',
                cash: formik.values.cash === '' || formik.values.cash === 0 ? 0 : Number(formik.values.cash?.toString()?.replace(/,/g, '')),
                swiftcode: formik.values.swiftcode.trim(),
                ledgeraccount: '',
                bankaccounttype: '',
                upi: formik.values.upi,
              };
              const res = await API.graphql(
                graphqlOperation(createBankDetails, {
                  createBankDetailsInput: updateBank,
                })
              );
            }
          }
          if (partyType === 'supplier') {
            if (setNewPartyID) {
              setNewPartyID(customerData[0]?.partyid);
            }
            if (listPartyDetails) {
              listPartyDetails(customerData[0]?.partyid);
            }
            if (setNewPartyName) {
              setNewPartyName(formik.values.legalName.trim());
            }
            closePartyModal(false, 'force');
          } else {
            navigate('/supplierList', { force: true });
          }
          dispatch(listAccountMasterv2Api.util.invalidateTags(['listAccountMaster']));
          showSuccessSnackbar('Supplier updated successfully');
        }
      }
      dispatch(dashboardApi.util.invalidateTags(['dashboard']));
      dispatch(listAccountOpeningBalanceApi.util.invalidateTags(['listAccountOpeningBalance']));
    } catch (error) {
      console.log(error);
      const rawMessage = error?.errors?.[0]?.message?.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
      setBackdropOpen(false);
      showWarningSnackbar(errorMessage);
    } finally {
      if (customModal) {
        dispatch(setModalBlocked(false));
      } else {
        dispatch(setNavigationBlocked(false));
      }
      setBackdropOpen(false);
    }
  }
  const { data: paymentSettingsList } = useGetPaymentSettingsQuery();
  const { enable_creditlimit: Enable_CreditLimit, enable_creditperiod: Enable_CreditPeriod } = paymentSettingsList?.[0] ?? {};
  useEffect(() => {
    if (Type && (Type === 'Accounts' || Type === 'Party') && newPartyName) {
      formik.setValues({
        ...formik.values,
        legalName: newPartyName,
        legalShortName: newPartyName,
      });
    }
  }, [newPartyName]);

  const ids = ['AddTdsTcsOptions'];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);
  useSaveShortcut(
    viewPage == true
      ? undefined
      : partyParamsID || customerState.id
      ? () => {
          if (!anyElementExists()) {
            saveEditChanges();
          }
        }
      : (e) => {
          if (!anyElementExists()) {
            saveChanges(e, { new: false });
          }
        }
  );

  const internalBaselineRef = useRef(null);

  useEffect(() => {
    if (viewPage) {
      if (customModal) {
        dispatch(setModalBlocked(false));
      } else {
        dispatch(setNavigationBlocked(false));
      }
      return;
    }
    const isEdit = idParams || partyParamsID;
    const hasAttachments = attachments?.length > 0;

    if (isEdit) {
      const isInitialLoad = Object.keys(formik.touched).length === 0;
      if (isInitialLoad && formik.values) {
        internalBaselineRef.current = formik.values;
      } else if (internalBaselineRef.current && formik.values) {
        const isDirty = JSON.stringify(internalBaselineRef.current) !== JSON.stringify(formik.values);
        if (customModal) {
          dispatch(setModalBlocked(isDirty || hasAttachments));
        } else {
          dispatch(setNavigationBlocked(isDirty || hasAttachments));
        }
      }
    } else {
      if (customModal) {
        dispatch(setModalBlocked(formik.dirty || hasAttachments));
      } else {
        dispatch(setNavigationBlocked(formik.dirty || hasAttachments));
      }
    }

    if (customerData?.[0]?.partylegalname) {
      dispatch(updateTitle(customerData[0].partylegalname));
    }
  }, [formik.touched, formik.dirty, attachments, viewPage, internalBaselineRef, customerData, customModal]);

  return (
    <Box className="PageHeight">
      <Box
        sx={{
          height: { lg: '100%' },
          overflow: { lg: 'hidden' },
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Box
            classes={{
              root: classes.root,
            }}
          >
            <Grid container>
              <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  sx={{
                    marginRight: '10px',
                    fontWeight: 'bold',
                    color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                  }}
                  variant="h2"
                >
                  General Details
                </Typography>
                <Box
                  sx={{
                    flexGrow: 1,
                    borderBottom: '1px solid ',
                    borderColor: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                  }}
                />
              </Grid>

              <>
                <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                  <FormikTextField
                    autofocus={true}
                    formik={formik}
                    setGstApi={setGstApi}
                    ref={gstref}
                    maxLength={15}
                    resetbool={resetbool}
                    name="gstin"
                    label={loc === true ? 'Customer GSTIN (if any)' : 'Supplier GSTIN (if any)'}
                    viewPage={viewPage}
                  />
                </Grid>
                <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                  <CustomAutocomplete
                    formik={formik}
                    name="gstCategory"
                    label="GST Category"
                    ref={catref}
                    options={loc === true ? gstCategoryOptions : gstCategoryOptions1}
                    viewPage={viewPage}
                  />
                </Grid>
              </>
              <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                <FormikTextField
                  resetbool={resetbool}
                  formik={formik}
                  name="pan"
                  ref={panref}
                  maxLength={10}
                  label="Permanent Account Number"
                  viewPage={viewPage}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING} className="relative">
                <CustomAutocomplete
                  formik={formik}
                  name="entity"
                  label={loc ? 'Customer Legal Entity' : 'Supplier Legal Entity'}
                  options={entityOptions}
                  viewPage={viewPage}
                  ref={entityref}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING} className="relative">
                <CustomAutocomplete
                  formik={formik}
                  name="pos"
                  label={loc ? 'Place of Supply' : 'Source of Supply'}
                  options={pos}
                  viewPage={viewPage}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING} className="relative">
                <FormikTextField
                  formik={formik}
                  resetbool={resetbool}
                  name="legalName"
                  ref={legalref}
                  label={loc ? 'Customer Legal Name' : 'Supplier Legal Name'}
                  viewPage={viewPage}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING} className="relative">
                <FormikTextField
                  formik={formik}
                  resetbool={resetbool}
                  name="legalShortName"
                  label={loc ? 'Customer Ledger Name' : 'Supplier Ledger Name'}
                  viewPage={viewPage}
                  ref={shortref}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                <NewCustomerGroup
                  key={loc}
                  loc={loc}
                  viewPage={viewPage}
                  label={loc === true ? 'Customer Group, if Applicable' : 'Supplier Group, if Applicable'}
                  onChange={(currentNode) => {
                    setCustomerGroup(currentNode.value[1]);
                  }}
                  defaultGroup={loc === true ? 15 : 7}
                  accountGroup={accountGroupData}
                  subGroup={subAccountGroupData}
                  setSubAccountGroupData={setSubAccountGroupData}
                  setCustomerGroup={setCustomerGroup}
                  partyGroupId={customerGroup}
                  parentDetails={parentdetails}
                  disabled={viewPage}
                  getAccountData={getAccountData}
                />

                <p style={{ padding: 9 }} />
              </Grid>
              {Enable_CreditLimit > 0 && (
                <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                  <FormikMoneyInput label="Credit Limit Amount" formik={formik} name="creditLimit" viewPage={viewPage} />
                </Grid>
              )}
              {Enable_CreditPeriod > 0 && (
                <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                  <FormikMoneyInput formik={formik} name="creditPeriod" label="Credit Period allowed (days)" viewPage={viewPage} />
                </Grid>
              )}
              <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING} className="relative">
                <CustomAutocomplete
                  formik={formik}
                  name="billingCurrency"
                  label="Billing Currency"
                  options={billingCurrencyOptions}
                  viewPage={viewPage}
                />
              </Grid>
              {loc === false && (
                <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                  <CustomAutocomplete
                    formik={formik}
                    loc={loc}
                    name="TDSSection"
                    label="TDS % if any"
                    options={tdsSections}
                    getAccountData={getAccountData}
                    viewPage={viewPage}
                  />
                </Grid>
              )}
              <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING} className="relative">
                <FormikTextField formik={formik} name="email" label="Email" resetbool={resetbool} viewPage={viewPage} />
              </Grid>
              <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                <MuiTelInput
                  key={`${contactNumber.MobileIso}-mobile`}
                  defaultCountry={contactNumber.MobileIso.toUpperCase() || 'IN'}
                  label="Mobile"
                  inputProps={{ maxLength: 15 }}
                  fullWidth
                  size="small"
                  disabled={viewPage}
                  onChange={(value, info) => {
                    if (info?.nationalNumber === '' && info?.reason === 'input') {
                      setContactNumber((prev) => ({
                        ...prev,
                        ['Mobile']: '',
                        [`MobileIso`]: prev.MobileIso,
                        errorFields: {
                          ...(prev.errorFields || {}),
                          ['Mobile']: '',
                        },
                        // [`MobileDial`]: info.numberType ? prev.MobileIso : dial,
                      }));
                    } else if (info?.nationalNumber || (info.countryCode && info.reason !== 'input')) {
                      handleMobileChange(value, 'Mobile', info);
                    }
                  }}
                  value={contactNumber.Mobile}
                  forceCallingCode={true}
                  // ref={contactref}
                  inputRef={contactref}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: 'bottom', // Aligns the dropdown vertically at the bottom of the input
                      horizontal: 'left', // Aligns the dropdown horizontally to the left of the input
                    },
                    transformOrigin: {
                      vertical: 'top', // Aligns the top of the dropdown with the bottom of the input
                      horizontal: 'left', // Aligns the left of the dropdown with the left of the input
                    },
                    PaperProps: {
                      className: 'custom-scrollbar',
                      sx: {
                        borderRadius: '8px', // Rounded corners
                        boxShadow: '0 3px 6px rgba(0,0,0,0.1)', // Shadow effect
                        height: '350px',
                      },
                    },
                  }}
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    },
                  }}
                />
                {contactNumber?.errorFields?.Mobile ? (
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {contactNumber?.errorFields?.Mobile}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '15px',
                      fontSize: '11px',

                      color: 'danger.main',
                    }}
                  ></Typography>
                )}
              </Grid>
              <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING} className="relative">
                <MuiTelInput
                  key={`whatsapp-${contactNumber.WhatsappIso}`}
                  defaultCountry={contactNumber.WhatsappIso.toUpperCase() || 'IN'}
                  label="whatsapp"
                  inputProps={{ maxLength: 15 }}
                  fullWidth
                  size="small"
                  disabled={viewPage}
                  onChange={(value, info) => {
                    if (info?.nationalNumber === '' && info?.reason === 'input') {
                      setContactNumber((prev) => ({
                        ...prev,
                        ['Whatsapp']: '',
                        [`WhatsappIso`]: prev.WhatsappIso,
                        errorFields: {
                          ...(prev.errorFields || {}),
                          ['Whatsapp']: '',
                        },
                        // [`MobileDial`]: info.numberType ? prev.MobileIso : dial,
                      }));
                    } else if (info?.nationalNumber || (info.countryCode && info.reason !== 'input')) {
                      handleMobileChange(value, 'Whatsapp', info);
                    }
                  }}
                  inputRef={whatsappref1}
                  value={contactNumber?.Whatsapp}
                  forceCallingCode={true}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: 'bottom', // Aligns the dropdown vertically at the bottom of the input
                      horizontal: 'left', // Aligns the dropdown horizontally to the left of the input
                    },
                    transformOrigin: {
                      vertical: 'top', // Aligns the top of the dropdown with the bottom of the input
                      horizontal: 'left', // Aligns the left of the dropdown with the left of the input
                    },
                    PaperProps: {
                      className: 'custom-scrollbar',
                      sx: {
                        borderRadius: '8px', // Rounded corners
                        boxShadow: '0 3px 6px rgba(0,0,0,0.1)', // Shadow effect
                        height: '350px',
                      },
                    },
                  }}
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    },
                  }}
                />
                {contactNumber?.errorFields?.Whatsapp ? (
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '11px',
                      color: 'danger.main',
                    }}
                  >
                    {contactNumber?.errorFields?.Whatsapp}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '15px',
                      fontSize: '11px',

                      color: 'danger.main',
                    }}
                  ></Typography>
                )}
              </Grid>
              {loc === false && (
                <>
                  <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING} className="relative">
                    <CustomAutocomplete
                      formik={formik}
                      name="msme"
                      label="MSME type if applicable"
                      options={msmeOptions}
                      viewPage={viewPage}
                    />
                  </Grid>
                  <Grid item lg={4} sm={6} xs={12} sx={FIELD_SPACING} className="relative">
                    <FormikTextField
                      formik={formik}
                      resetbool={resetbool}
                      name="reg"
                      label="Udyam Registration Number if applicable"
                      viewPage={viewPage}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  sx={{
                    marginRight: '10px',
                    fontWeight: 'bold',
                    color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                  }}
                  variant="h2"
                >
                  Billing Address
                </Typography>
                <Box
                  sx={{
                    flexGrow: 1,
                    borderBottom: '1px solid ',
                    borderColor: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                    marginTop: '10px',
                  }}
                />
              </Grid>
              <Grid item lg={3} sm={6} xs={12} sx={{ padding: '0px 10px', marginTop: '15px' }} className="relative">
                <CustomAutocomplete formik={formik} name="Country" label="Country" options={CountryList} viewPage={viewPage} />
              </Grid>
              <Grid
                item
                lg={3}
                sm={6}
                xs={12}
                sx={{
                  padding: '0px 10px',
                  marginTop: { xs: '15px' },
                }}
                className="relative"
              >
                <FormikTextField
                  resetbool={resetbool}
                  formik={formik}
                  name="Pincode"
                  cityref={cityref}
                  states={statesLists}
                  label="Postal/Zipcode"
                  viewPage={viewPage}
                  setOptions={setOptionB}
                />
              </Grid>
              <Grid
                item
                lg={3}
                sm={6}
                xs={12}
                sx={{
                  padding: '0px 10px',
                  marginTop: { xs: '15px' },
                }}
                className="relative"
              >
                {formik.values.Country === 'IndiaState' ? (
                  <CustomAutocomplete
                    formik={formik}
                    name="State"
                    label="State"
                    district={true}
                    options={statesLists}
                    viewPage={viewPage}
                  />
                ) : (
                  <FormikTextField
                    resetbool={resetbool}
                    formik={formik}
                    name="foreignstate"
                    district={true}
                    label="State/Province"
                    viewPage={viewPage}
                  />
                )}
              </Grid>

              <Grid
                item
                lg={3}
                sm={6}
                xs={12}
                sx={{
                  padding: '0px 10px',
                  marginTop: { xs: '15px' },
                }}
                className="relative"
              >
                <FormikTextField
                  formik={formik}
                  resetbool={resetbool}
                  name="billingAddress"
                  label="Door No, Building name, Road name"
                  rows={3}
                  maxLength={200}
                  viewPage={viewPage}
                />
              </Grid>
              <Grid
                item
                lg={3}
                sm={6}
                xs={12}
                sx={{
                  padding: '0px 10px',
                  marginTop: { xs: '10px', lg: '-40px' },
                }}
                className="relative"
              >
                {formik.values.Country === 'IndiaState' ? (
                  <CustomAutocomplete
                    formik={formik}
                    name="District"
                    label="District"
                    district={true}
                    options={districtsLists1 ? districtsLists1 : []}
                    viewPage={viewPage}
                  />
                ) : (
                  <FormikTextField
                    resetbool={resetbool}
                    formik={formik}
                    name="foreigndistrict"
                    label="District"
                    district={true}
                    viewPage={viewPage}
                  />
                )}
              </Grid>
              <Grid
                item
                lg={3}
                sm={6}
                xs={12}
                sx={{
                  padding: '0px 10px',
                  marginTop: { xs: '10px', lg: '-40px' },
                }}
                className="relative"
              >
                <Autocomplete
                  openOnFocus
                  freeSolo
                  name="city"
                  disabled={viewPage}
                  options={optionB}
                  value={formik.values.City}
                  onInputChange={(event, newInputValue) => {
                    formik.setFieldValue('City', newInputValue);
                  }}
                  onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                      formik.setFieldValue('City', newValue);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="City"
                      inputRef={cityref}
                      InputLabelProps={{ sx: { top: !formik.values.City ? '-7px' : '-3px' } }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                <Accordion
                  expanded={expanded['panel2'] === true ? true : false}
                  onChange={handleExChange('panel2')}
                  sx={{
                    width: '100%',
                    boxShadow: 'none',
                    '&.MuiAccordionSummary-root': {
                      padding: '0px',
                      backgroundColor: 'transparent',
                    },
                    '&.MuiAccordionSummary-content': {
                      alignItems: 'center',
                      backgroundColor: 'transparent',
                    },
                    '& .MuiAccordionDetails-root': {
                      backgroundColor: 'transparent',
                    },
                    backgroundColor: 'transparent',
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    classes={{ root: classes.accordionSummary }}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      '&.MuiAccordionSummary-root': {
                        padding: '0px',
                      },
                      '&.MuiAccordionSummary-contentGutters': {
                        display: 'flex',
                        alignItems: 'center',
                      },
                      '&.MuiAccordionSummary-content': {
                        alignItems: 'center',
                      },
                      backgroundColor: 'transparent',
                    }}
                    IconButtonProps={{
                      style: {
                        marginRight: '8px',
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 'bold',
                      }}
                      variant="h2"
                    >
                      {loc === true ? 'Ship to Address' : 'Ship From Address'}
                    </Typography>
                    <Checkbox
                      size="medium"
                      sx={{
                        marginLeft: '5px',
                        '&.MuiCheckbox-root': {
                          padding: '0px',
                        },
                      }}
                      id="copy-address"
                      name="copy-address"
                      onClick={(event) => {
                        event.stopPropagation();
                        setBool(!bool);
                        if (event.target.checked === false && !customerState?.view && !partyParamsID) {
                          formik.setFieldValue('CityD', '');
                          formik.setFieldValue('billingAddressD', '');
                          formik.setFieldValue('PincodeD', '');
                          formik.setFieldValue('StateD', '');
                          formik.setFieldValue('DistrictD', '');
                          formik.setFieldValue('CountryD', '');
                          formik.setFieldValue('ConsigneeGSTIN', '');
                          formik.setFieldValue('ConsigneeName', '');
                        } else if (event.target.checked === true && !customerState?.view && !partyParamsID) {
                          formik.setFieldValue('CityD', formik.values.City);
                          formik.setFieldValue('billingAddressD', formik.values.billingAddress);
                          formik.setFieldValue('PincodeD', formik.values.Pincode);
                          formik.setFieldValue('StateD', formik.values.State);
                          formik.setFieldValue('DistrictD', formik.values.District);
                          formik.setFieldValue('foreignstateD', formik.values.foreignstate);
                          formik.setFieldValue('foreigndistrictD', formik.values.foreigndistrict);
                          formik.setFieldValue('CountryD', formik.values.Country);
                          formik.setFieldValue('ConsigneeGSTIN', formik.values.gstin);
                          formik.setFieldValue('ConsigneeName', formik.values.legalShortName);
                        }
                      }}
                      checked={bool === true ? true : false}
                      disabled={viewPage}
                    />
                    <FormLabel
                      htmlFor="copy-address"
                      sx={{
                        fontSize: '14px',
                        color: 'input.font',
                        marginRight: '10px',
                      }}
                    >
                      Same as above
                    </FormLabel>
                    <Box
                      sx={{
                        position: 'absolute',
                        left: '310px',
                        top: '25px',
                        right: 0,
                        borderBottom: '1px solid ',
                        borderColor: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                        width: {
                          xs: '0px',
                          sm: 'calc(100vw - 340px)',
                        },
                      }}
                    />
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      '&.MuiAccordionDetails-root': {
                        padding: '0px',
                      },
                    }}
                  >
                    <Grid xs={12} item container>
                      <Grid xs={12} item container>
                        <Grid
                          item
                          lg={3}
                          sm={6}
                          xs={12}
                          sx={{
                            padding: '0px 10px',
                            marginTop: { xs: '5px', lg: '0px' },
                          }}
                          className="relative"
                        >
                          <CustomAutocomplete
                            formik={formik}
                            name="CountryD"
                            label="Country"
                            disabled={bool === true ? true : false}
                            options={CountryList}
                            viewPage={viewPage}
                          />
                        </Grid>
                        <Grid
                          item
                          lg={3}
                          sm={6}
                          xs={12}
                          sx={{
                            padding: '0px 10px',
                            marginTop: { xs: '5px', lg: '0px' },
                          }}
                          className="relative"
                        >
                          <FormikTextField
                            formik={formik}
                            resetbool={resetbool}
                            name="PincodeD"
                            disabled={bool === true ? true : false}
                            states={statesLists}
                            cityref={cityrefD}
                            label="Postal/Zipcode"
                            viewPage={viewPage}
                            setOptions={setOptionD}
                          />
                        </Grid>
                        <Grid
                          item
                          lg={3}
                          sm={6}
                          xs={12}
                          sx={{
                            padding: '0px 10px',
                            marginTop: { xs: '5px', lg: '0px' },
                          }}
                          className="relative"
                        >
                          {formik.values.CountryD === 'IndiaState' ? (
                            <CustomAutocomplete
                              formik={formik}
                              name="StateD"
                              label="State"
                              disabled={bool === true ? true : false}
                              options={statesLists}
                              viewPage={viewPage}
                            />
                          ) : (
                            <FormikTextField
                              resetbool={resetbool}
                              formik={formik}
                              name="foreignstateD"
                              label="State"
                              disabled={bool === true ? true : false}
                              district={true}
                              viewPage={viewPage}
                            />
                          )}
                        </Grid>
                        <Grid
                          item
                          lg={3}
                          sm={6}
                          xs={12}
                          sx={{
                            padding: '0px 10px',
                            marginTop: { xs: '5px', lg: '0px' },
                          }}
                          className="relative"
                        >
                          <FormikTextField
                            formik={formik}
                            resetbool={resetbool}
                            name="billingAddressD"
                            label="Delivery Address"
                            disabled={bool === true ? true : false}
                            rows={3}
                            viewPage={viewPage}
                            maxLength={200}
                          />
                        </Grid>
                        <Grid
                          item
                          lg={3}
                          sm={6}
                          xs={12}
                          sx={{
                            padding: '0px 10px',
                            marginTop: { xs: '5px', lg: '-45px' },
                          }}
                          className="relative"
                        >
                          {formik.values.CountryD === 'IndiaState' ? (
                            <CustomAutocomplete
                              formik={formik}
                              name="DistrictD"
                              label="District"
                              disabled={bool === true ? true : false}
                              options={districtsLists2 ? districtsLists2 : []}
                              viewPage={viewPage}
                              district={true}
                            />
                          ) : (
                            <FormikTextField
                              formik={formik}
                              resetbool={resetbool}
                              name="foreigndistrictD"
                              label="District"
                              district={true}
                              disabled={bool === true ? true : false}
                              viewPage={viewPage}
                            />
                          )}
                        </Grid>
                        <Grid
                          item
                          lg={3}
                          sm={6}
                          xs={12}
                          sx={{
                            padding: '0px 10px',
                            marginTop: { xs: '5px', lg: '-45px' },
                          }}
                          className="relative"
                        >
                          <Autocomplete
                            openOnFocus
                            freeSolo
                            name="city"
                            disabled={bool === true ? true : false || viewPage}
                            options={optionD}
                            value={formik.values.CityD}
                            onInputChange={(event, newInputValue) => {
                              formik.setFieldValue('CityD', newInputValue);
                            }}
                            onChange={(event, newValue) => {
                              if (typeof newValue === 'string') {
                                formik.setFieldValue('CityD', newValue);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="City"
                                inputRef={cityrefD}
                                InputLabelProps={{ sx: { top: !formik.values.CityD ? '-7px' : '-3px' } }}
                              />
                            )}
                          />

                          <p style={{ padding: 9 }} />
                        </Grid>
                      </Grid>
                      {/* {loc === true && ( */}
                      <Grid xs={12} item container>
                        <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                          <FormikTextField
                            formik={formik}
                            resetbool={resetbool}
                            name="ConsigneeName"
                            label="Consignee Name"
                            viewPage={viewPage}
                            disabled={bool === true ? true : false || viewPage}
                          />
                        </Grid>
                        <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                          <FormikTextField
                            formik={formik}
                            resetbool={resetbool}
                            name="ConsigneeGSTIN"
                            label="Consignee GSTIN"
                            viewPage={viewPage}
                            disabled={bool === true ? true : false || viewPage}
                          />
                        </Grid>
                      </Grid>
                      {/* )} */}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>

              <Grid
                xs={12}
                style={{
                  position: 'relative',
                  marginLeft: '-13px',
                }}
              >
                <Accordion
                  classes={{ root: classes.accordionRoot }}
                  expanded={expanded['panel1'] || false}
                  onChange={handleExChange('panel1')}
                  sx={{ zIndex: '100', width: '100%' }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    classes={{ root: classes.accordionSummary }}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ display: 'inline-flex' }}
                    IconButtonProps={{
                      style: {
                        marginRight: '8px',
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        marginRight: '10px',
                        fontWeight: 'bold',
                      }}
                      variant="h2"
                    >
                      Contact Person Details
                    </Typography>
                    <Box
                      sx={{
                        position: 'absolute',
                        left: '225px',
                        right: 0,
                        bottom: '25px',
                        borderBottom: '1px solid ',
                        borderColor: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                        width: {
                          xs: '0px',
                          sm: 'calc(100vw - 250px)',
                        },
                      }}
                    />
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid item container lg={12}>
                      <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                        <FormikTextField label="Full Name" resetbool={resetbool} formik={formik} name="fullname" viewPage={viewPage} />
                      </Grid>
                      <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                        <FormikTextField label="Designation" resetbool={resetbool} formik={formik} viewPage={viewPage} name="Designation" />
                      </Grid>
                      <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                        <MuiTelInput
                          key={`contact-mobile-${contactPerson.MobileIso}`}
                          defaultCountry={contactPerson.MobileIso.toUpperCase() || 'IN'}
                          label="Mobile"
                          inputProps={{ maxLength: 15 }}
                          fullWidth
                          size="small"
                          disabled={viewPage}
                          inputRef={mobileref}
                          PopperProps={{
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, -8],
                                },
                              },
                              {
                                name: 'preventOverflow',
                                options: {
                                  boundary: 'viewport',
                                  padding: 8,
                                },
                              },
                            ],
                            style: {
                              zIndex: 1300,
                              // marginTop: '40px',
                              maxHeight: '200px', // limit dropdown height
                            },
                            placement: 'top-start',
                          }}
                          onChange={(value, info) => {
                            if (info?.nationalNumber === '' && info?.reason === 'input') {
                              setContactPerson((prev) => ({
                                ...prev,
                                ['Mobile']: '',
                                [`MobileIso`]: prev.MobileIso,
                                errorFields: {
                                  ...(prev.errorFields || {}),
                                  ['Mobile']: '',
                                },
                              }));
                            } else if (info?.nationalNumber || (info.countryCode && info.reason !== 'input')) {
                              handlecontactPersonMobileChange(value, 'Mobile', info);
                            }
                          }}
                          value={contactPerson.Mobile}
                          forceCallingCode={true}
                          MenuProps={{
                            PaperProps: {
                              className: 'custom-scrollbar',
                              sx: {
                                borderRadius: '8px', // Rounded corners
                                boxShadow: '0 3px 6px rgba(0,0,0,0.1)', // Shadow effect
                                height: '200px',
                                overflow: 'auto',
                              },
                            },
                            disableScrollLock: true,
                            keepMounted: false,
                            variant: 'menu',
                            autoFocus: false,
                            disableAutoFocusItem: true,
                          }}
                          sx={{
                            '.MuiFormLabel-asterisk': {
                              color: 'danger.main',
                              fontSize: '20px',
                              fontWeight: 'bold',
                            },
                          }}
                        />
                        {contactPerson?.errorFields?.Mobile ? (
                          <Typography
                            sx={{
                              marginTop: '2px',
                              marginLeft: '10px',
                              marginBottom: '0px',
                              fontSize: '11px',
                              color: 'danger.main',
                            }}
                          >
                            {contactPerson?.errorFields?.Mobile}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              marginTop: '2px',
                              marginLeft: '10px',
                              marginBottom: '15px',
                              fontSize: '11px',

                              color: 'danger.main',
                            }}
                          ></Typography>
                        )}
                      </Grid>
                      <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                        <MuiTelInput
                          key={`contact-whatsapp-${contactPerson.WhatsappIso}`}
                          defaultCountry={contactPerson.WhatsappIso.toUpperCase() || 'IN'}
                          label="whatsapp"
                          inputProps={{ maxLength: 15 }}
                          fullWidth
                          size="small"
                          disabled={viewPage}
                          onChange={(value, info) => {
                            if (info?.nationalNumber === '' && info?.reason === 'input') {
                              setContactPerson((prev) => ({
                                ...prev,
                                ['Whatsapp']: '',
                                [`WhatsappIso`]: prev.WhatsappIso,
                                errorFields: {
                                  ...(prev.errorFields || {}),
                                  ['Whatsapp']: '',
                                },
                                // [`MobileDial`]: info.numberType ? prev.MobileIso : dial,
                              }));
                            } else if (info?.nationalNumber || (info.countryCode && info.reason !== 'input')) {
                              handlecontactPersonMobileChange(value, 'Whatsapp', info);
                            }
                          }}
                          inputRef={whatsappref2}
                          value={contactPerson?.Whatsapp}
                          forceCallingCode={true}
                          PopperProps={{
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, -8], // Always add space above
                                },
                              },
                              {
                                name: 'preventOverflow',
                                options: {
                                  boundary: 'viewport',
                                  padding: 8,
                                },
                              },
                            ],
                            style: {
                              zIndex: 1300,
                              maxHeight: '200px',
                            },
                            placement: 'top-start',
                          }}
                          MenuProps={{
                            PaperProps: {
                              className: 'custom-scrollbar',
                              sx: {
                                borderRadius: '8px', // Rounded corners
                                boxShadow: '0 3px 6px rgba(0,0,0,0.1)', // Shadow effect
                                maxHeight: '200px', // limit dropdown height instead of fixed height
                                overflow: 'auto',
                              },
                            },
                            disableScrollLock: true,
                            keepMounted: false,
                            variant: 'menu',
                            autoFocus: false,
                            disableAutoFocusItem: true,
                          }}
                          sx={{
                            '.MuiFormLabel-asterisk': {
                              color: 'danger.main',
                              fontSize: '20px',
                              fontWeight: 'bold',
                            },
                          }}
                        />
                        {contactPerson?.errorFields?.Whatsapp ? (
                          <Typography
                            sx={{
                              marginTop: '2px',
                              marginLeft: '10px',
                              marginBottom: '0px',
                              fontSize: '11px',
                              color: 'danger.main',
                            }}
                          >
                            {contactPerson?.errorFields?.Whatsapp}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              marginTop: '2px',
                              marginLeft: '10px',
                              marginBottom: '15px',
                              fontSize: '11px',

                              color: 'danger.main',
                            }}
                          ></Typography>
                        )}
                      </Grid>
                      <Grid item lg={3} sm={6} xs={12} sx={FIELD_SPACING}>
                        <FormikTextField resetbool={resetbool} formik={formik} name="EmailContact" label="Email" viewPage={viewPage} />
                      </Grid>
                      <Grid item lg={6} xs={12} sx={FIELD_SPACING}>
                        <FormikTextField
                          resetbool={resetbool}
                          formik={formik}
                          name="notes"
                          maxLength={100}
                          viewPage={viewPage}
                          label="Comments/Remarks"
                          // rows="1"
                        />
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>

              {loc === false && (
                <Grid
                  xs={12}
                  style={{
                    width: '100%',
                    position: 'relative',
                    marginLeft: '-13px',
                  }}
                >
                  <Accordion
                    classes={{ root: classes.accordionRoot }}
                    expanded={expanded['panel3'] || false}
                    onChange={handleExChange('panel3')}
                    sx={{
                      width: '100%',
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3-content"
                      classes={{ root: classes.accordionSummary }}
                      id="panel3-header"
                      sx={{ display: 'inline-flex' }}
                      IconButtonProps={{
                        style: {
                          marginRight: '8px',
                        },
                      }}
                    >
                      <Typography
                        sx={{
                          marginRight: '10px',
                          fontWeight: 'bold',
                        }}
                        variant="h2"
                      >
                        Supplier Bank Settings
                      </Typography>
                      <Box
                        sx={{
                          position: 'absolute',
                          right: 0,
                          bottom: '25px',
                          borderBottom: '1px solid ',
                          borderColor: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                          width: {
                            xs: '0px', // width on extra-small screens, 40px is an arbitrary value for left/right padding
                            sm: 'calc(100vw - 150px)',
                          },
                          left: '225px',
                        }}
                      />
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container>
                        <Grid item container xs={12} lg={9} sx={{ marginTop: { lg: '10px' } }}>
                          <Grid item lg={3} sm={6} xs={12} sx={{ padding: '0px 10px', marginTop: '10px' }}>
                            <FormikTextField resetbool={resetbool} formik={formik} name="ifsc" label="IFSC code" viewPage={viewPage} />
                          </Grid>
                          <Grid item lg={3} sm={6} xs={12} sx={{ padding: '0px 10px', marginTop: '10px' }}>
                            <FormikTextField resetbool={resetbool} label="Bank Name" disabled={viewPage} name="bankName" formik={formik} />
                          </Grid>

                          <Grid item lg={3} sm={6} xs={12} sx={{ padding: '0px 10px', marginTop: '10px' }}>
                            <FormikTextField
                              resetbool={resetbool}
                              formik={formik}
                              name="swiftcode"
                              label="Swift Code"
                              viewPage={viewPage}
                            />
                          </Grid>
                          <Grid item lg={3} sm={6} xs={12} sx={{ padding: '0px 10px', marginTop: '10px' }}>
                            <FormikTextField
                              resetbool={resetbool}
                              formik={formik}
                              name="bankAC"
                              label="Bank Account Number"
                              viewPage={viewPage}
                            />
                          </Grid>
                          <Grid item lg={3} sm={6} xs={12} sx={{ padding: '0px 10px', marginTop: '10px' }}>
                            <CustomAutocomplete
                              formik={formik}
                              name="cash"
                              label={'Account Type'}
                              options={cashAccounts}
                              viewPage={viewPage}
                            />
                          </Grid>
                          <Grid item container lg={3} sm={6} xs={12} sx={{ padding: '0px 10px', marginTop: '10px' }}>
                            <FormikTextField resetbool={resetbool} label="Branch Name" formik={formik} disabled={viewPage} name="branch" />
                          </Grid>
                        </Grid>
                        <Divider orientation="vertical" flexItem sx={{ borderRightWidth: 1, borderColor: 'black' }} />
                        <Grid item container xs={12} lg={2.75} sx={{ marginTop: { lg: '10px' } }}>
                          <Grid item lg={9} sm={6} xs={12} sx={{ padding: '0px 10px', marginTop: '10px' }}>
                            <FormikTextField
                              formik={formik}
                              resetbool={resetbool}
                              name="upi"
                              ref={upiRef}
                              label="Supplier UPI ID"
                              viewPage={viewPage}
                              placeholder="example@ybl"
                              upiChange={upiChange}
                            />
                            <Popper open={showSuggestions} anchorEl={anchorEl} placement="bottom-start" style={{ zIndex: 1300 }}>
                              <ClickAwayListener onClickAway={handleClickAway}>
                                <Paper
                                  style={{
                                    maxHeight: 200,
                                    overflowY: 'auto',
                                    marginTop: 4,
                                  }}
                                >
                                  <List dense>
                                    {filteredSuggestions.map((suggestion, index) => (
                                      <ListItem button key={index} onClick={() => handleSuggestionClick(suggestion)}>
                                        {suggestion}
                                      </ListItem>
                                    ))}
                                  </List>
                                </Paper>
                              </ClickAwayListener>
                            </Popper>
                            {console.log(anchorEl, 'anchorel')}
                            {/* )} */}
                            {formik.values.upi && !formik.errors.upi && qrupi && (
                              <Typography variant="caption">Scan this QR to make a payment</Typography>
                            )}
                          </Grid>

                          <Grid
                            item
                            lg={3}
                            sm={6}
                            xs={12}
                            // sx={{ padding: "0px 10px", marginTop: "10px" }}
                          >
                            {/* {formik.values.upi &&
                              !formik.errors.upi &&
                              qrupi && ( */}
                            <img
                              // style={{ opacity: 0.5 }}
                              // src={qrupi}
                              src={qrupi ? qrupi : sampleQR}
                              alt="UPI QR Code"
                              height="100px"
                            />
                            {/* )} */}
                          </Grid>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              )}
              <Grid
                item
                lg={3}
                xs={12}
                sx={{
                  padding: '0px 10px',
                  marginTop: { xs: '15px', md: '0px' },
                }}
              >
                <Typography
                  sx={{
                    marginRight: '10px',
                    fontWeight: 'bold',
                    marginBottom: { xs: '5px' },
                    color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                  }}
                  variant="h2"
                >
                  Comments
                </Typography>
                <FormikTextField formik={formik} name="Comments" rows={7} viewPage={viewPage} resetbool={resetbool} maxLength={250} />
              </Grid>
              <Grid item container lg={9} xs={12}>
                <Grid item lg={6} xs={12} sx={{ display: 'flex' }}>
                  <Typography
                    sx={{
                      marginRight: '10px',
                      fontWeight: 'bold',
                      marginBottom: '5px',
                      color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                    }}
                    variant="h2"
                  >
                    Documents
                  </Typography>
                  <input
                    ref={imageRef}
                    type="file"
                    id="fileInput"
                    onChange={handleFileChange}
                    multiple
                    style={{ display: 'none' }}
                    accept="
                    application/msword,
                    application/pdf,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.ms-excel,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    application/vnd.ms-powerpoint,
                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                    image/jpeg,
                    image/jpg,
                    image/png
                  "
                  />
                  <CustomTooltip title="Rolling out soon" placement="top">
                    <span style={{ height: '10%', width: '50%' }}>
                      <Button
                        onClick={() => imageRef?.current?.click()}
                        size="small"
                        variant="contained"
                        // disabled={viewPage}
                        disabled={true}
                        sx={{
                          fontSize: '12px',
                          position: 'relative',
                          padding: '0px 2px',
                          marginBottom: loc === true ? '30px' : '30px',
                          boxShadow: 'none',
                          display: viewPage ? 'none' : '',
                          marginTop: loc === true ? '-13px' : '-4px',
                          height: '30px',
                        }}
                      >
                        <span>
                          <AddIcon fontSize="15px" />
                          ADD DOCUMENT
                        </span>
                        {attachments?.length > 0 && (
                          <span
                            style={{
                              color: 'white',
                              position: loc === true ? 'relative' : 'static',
                              top: '5px',
                            }}
                          >
                            {'\xa0' + `(${attachments?.length} out of 6)`}
                          </span>
                        )}
                      </Button>
                    </span>
                  </CustomTooltip>
                </Grid>

                {attachments?.length > 0 && (
                  <Grid xs={12} style={{ marginTop: '-20px' }}>
                    <Attachment
                      view={viewPage}
                      attachments={attachments}
                      setAttachments={setAttachments}
                      updateAttachmentName={updateAttachmentName}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Box>
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </form>
        <ConfirmCancel open={cancelModal} setOpen={setCancelModal} path={loc === true ? 'customerList' : 'supplierList'} />
        <DraggableAction
          actionType={(partyParamsID || (customerState?.id && customModal === false)) && viewPage !== true ? 'edit' : 'save'}
          onCancel={
            partyParamsID || (customerState?.id && customModal === false)
              ? () => {
                  customerData?.is_active == 1 ? activateThis(0) : activateThis(1);
                }
              : null
          }
          onSave={
            viewPage == true
              ? null
              : customerState?.id || partyParamsID
              ? () => {
                  saveEditChanges();
                }
              : (e) => saveChanges(e, { new: false })
          }
          onEnableEdit={() => {
            if (customerData[0]?.is_active == 0) {
              return activateThis(1);
            }
            if (closePartyModal && typeof closePartyModal === 'function') {
              passFn();
            } else {
              if (loc === true) {
                // if (location.search.includes('view=true')) {
                //   navigate('/editcustomer', {
                //     state: {
                //       id: customerData[0].partyid,
                //     },
                //   });
                // } else {
                navigate('/editcustomer', {
                  state: {
                    id: customerData[0].partyid,
                    existingData: {
                      customerData,
                      billingAddress,
                      deliveryAddress,
                      bankData,
                      contactNumber,
                      contactPerson,
                      attachments,
                      bool,
                      accountGroupData,
                      subAccountGroupData,
                      tdsSections,
                    },
                  },
                });
                // }
                // }
                //  else {
                //   if (location.search.includes('view=true')) {
                //     navigate('/editsupplier', {
                //       state: {
                //         id: customerData[0].partyid,
                //       },
                //     });
              } else {
                navigate('/editsupplier', {
                  state: {
                    id: customerData[0].partyid,
                    existingData: {
                      customerData,
                      billingAddress,
                      deliveryAddress,
                      bankData,
                      contactNumber,
                      contactPerson,
                      attachments,
                      bool,
                      accountGroupData,
                      subAccountGroupData,
                      tdsSections,
                    },
                  },
                });
              }
            }
            // }
          }}
          loading={customerData === undefined}
          onSaveNew={
            viewPage == true || partyType
              ? undefined
              : customerState?.id || partyParamsID
              ? () => {
                  saveEditChanges();
                }
              : (e) => saveChanges(e, { new: true })
          }
          id={partyParamsID || (customerState?.id && customModal === false)}
          stat={customerData && customerData[0]?.is_active == 1 ? 'inactive' : 'active'}
          onExit={() => {
            Type ? closePartyModal(false) : loc === true ? navigate('/customerList') : navigate('/supplierList');
          }}
          type={Type}
          onReset={
            viewPage === true
              ? null
              : customerState?.id || partyParamsID
              ? () => {
                  formik.resetForm({ values: initialValues });
                  setResetBool((c) => c + 1);
                  setTimeout(() => {
                    formik.validateForm().then((errors) => {
                      formik.setErrors(errors);
                    });
                  }, 0);
                  getPartyMasterData(partyParamsID || customerState?.id);
                }
              : customerState?.view == true
              ? null
              : () => {
                  formik.resetForm({ values: initialValues });
                  setResetBool((c) => c + 1);
                  setTimeout(() => {
                    formik.validateForm().then((errors) => {
                      formik.setErrors(errors);
                    });
                  }, 0);
                }
          }
        />
      </Box>
    </Box>
  );
};

export default AddNewCustomer;
